import React, {
  useContext,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import {
  ChevronFirst,
  ChevronLast,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";
import { DownloadContext } from "./DownloadContext";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { oneLight } from "react-syntax-highlighter/dist/esm/styles/prism";
import SortHome from "../images/SortHome.svg";
import FilterHome from "../images/filterHome.svg";
import Logo from "../images/logo.png";
import fullscreeen from "../images/fullscreen.png";
import zoomin from "../images/zoomin.png";
import zoomout from "../images/zoomout.png";
import moveIcon from "../images/move.png";
import deleteIcon from "../images/trash.png";
import DeletePopup from "../images/deletePopup.svg";
import deleteIcon3 from "../images/mediaPlayer/trash1.svg";
import IconJPG from "../images/icon-jpg.svg";
import IconPNG from "../images/icon-png.svg";
import IconPSD from "../images/icon-psd.svg";
import IconPDF from "../images/pdf.svg";
import IconFolder from "../images/folder.png";
import IconJfif from "../images/jfif.png";
import IconMsi from "../images/msi.png";
import SearchIcon from "../images/SearchIcon.svg";
import IconZip from "../images/zip.png";
import IconJpeg from "../images/jpeg.png";
import IconHome from "../images/Grid.svg";
import IconList from "../images/list.svg";
import IconHomeW from "../images/GridWhite.svg";
import IconListW from "../images/listWhite.svg";
import copyIcon from "../images/DropdownIcons/copyIcon.svg";
import deleteIcon2 from "../images/DropdownIcons/deleteIcon.svg";
import downloadIcon from "../images/DropdownIcons/downloadIcon.svg";
import ZipIcon from "../images/DropdownIcons/Zip.svg";
import UnZipIcon from "../images/DropdownIcons/Unzip.svg";
import InfoIcon from "../images/DropdownIcons/InfoIcon.svg";
import favouritesIcon from "../images/DropdownIcons/favouritesIcon.svg";
import linkIcon from "../images/DropdownIcons/linkIcon.svg";
import moveIcon2 from "../images/DropdownIcons/MoveIcon.svg";
import renameIcon from "../images/DropdownIcons/renameIcon.svg";
import shareIcon from "../images/DropdownIcons/shareIcon.svg";
import eyeIcon from "../images/DropdownIcons/eyeIcon.svg";
import BackgroundImageFileUpload from "../images/Background.svg";
import UploadIcon from "../images/UploadIcon.svg";
// import IconUpload from "../images/iconUpload.svg";
import SortIcon from "../images/sort-style-1.svg";
import createFolderPopup from "../images/createFolderPopup.svg";
import IconVideo from "../images/video.svg";
import ReactPlayer from "react-player";
import { Link } from "react-router-dom";
import loaderGif from "../images/Loaders/Animation4.gif";
import {
  Tooltip,
  Whisper,
  SelectPicker,
  Dropdown,
  Modal,
  Popover,
  Placeholder,
  Button,
} from "rsuite";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Dropzone from "react-dropzone";
import "rsuite/Tooltip/styles/index.css";
import "rsuite/SelectPicker/styles/index.css";
import "rsuite/dist/rsuite.min.css";
import { useDropzone } from "react-dropzone";
import SideNav from "../components/SideNav";
import Footer from "../components/Footer";
import ToggleNav from "../components/ToggleNav";
import IconUpload from "../images/iconUpload.svg";
import CreateFolder from "../images/CreateFolderNavbar.svg";
import DownloafFromUrl from "../images/Download_Link_Icon_1 1.svg";
import { ChakraProvider, Stack, useToast } from "@chakra-ui/react";
import { UploadContext } from "./UploadContext";
import { Modal as BootstrapModal } from "react-bootstrap";
//LIGHTBOX
import Lightbox from "yet-another-react-lightbox";
import MoveFilePopup from "./MoveFilePopup";
import MoveFolderPopup from "./MoveFolderPopup";
import CopyFilePopup from "./CopyFilePopup";
import "yet-another-react-lightbox/styles.css";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Video from "yet-another-react-lightbox/plugins/video";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/captions.css";
import ReactVideoThumbnail from "react-video-thumbnail";
import axios from "axios";
import { useLocation, useNavigate, useNavigationType } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

//Anurag Imports
import {
  addToken,
  incrementCounter,
  removeLastToken,
  decrementCounter,
  setFolderPath,
  addFolder,
  incrementFCounter,
  replacelasttoken,
  breadCrum,
  resetFolderList,
} from "../store/fileSlicer";
import DownloadModal from "./DownloadModal/DownloadModal";
import SelectFolderModal from "./DownloadModal/SelectFolderModal";

export const ListIcon = ({ className, onClick, alt, active }) => {
  // Use white color when active, gray when inactive
  const color = active ? "#FFFFFF" : "#5D6B7A";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
      alt={alt}
    >
      <circle cx="4" cy="6" r="2" fill={color} />
      <rect x="8" y="5" width="12" height="2" rx="1" fill={color} />
      <circle cx="4" cy="12" r="2" fill={color} />
      <rect x="8" y="11" width="12" height="2" rx="1" fill={color} />
      <circle cx="4" cy="18" r="2" fill={color} />
      <rect x="8" y="17" width="12" height="2" rx="1" fill={color} />
    </svg>
  );
};

// Grid Icon Component
export const GridIcon = ({ className, onClick, alt, active }) => {
  // Use white color when active, gray when inactive
  const color = active ? "#FFFFFF" : "#5D6B7A";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
      alt={alt}
    >
      <rect
        x="3"
        y="3"
        width="7"
        height="7"
        rx="1"
        stroke={color}
        strokeWidth="2"
        fill="none"
      />
      <rect
        x="14"
        y="3"
        width="7"
        height="7"
        rx="1"
        stroke={color}
        strokeWidth="2"
        fill="none"
      />
      <rect
        x="3"
        y="14"
        width="7"
        height="7"
        rx="1"
        stroke={color}
        strokeWidth="2"
        fill="none"
      />
      <rect
        x="14"
        y="14"
        width="7"
        height="7"
        rx="1"
        stroke={color}
        strokeWidth="2"
        fill="none"
      />
    </svg>
  );
};

const NestedPage = () => {
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);

  const handleDownload = async (downloadInfo) => {
    // console.log("Downloading:", downloadInfo);
    // console.log("Download path:", downloadPath);
    // Implement your actual download logic here
    // You would typically use fetch or axios to download the file
  };
  const openPathSelectionModal = () => {
    setMoveFol(true);
  };

  const closePathSelectionModal = (selectedPath) => {
    setMoveFol(false);
    if (selectedPath) {
      setDownloadPath(selectedPath);
    }
  };

  const { addUpload, updateUploadProgress, removeUpload } =
    useContext(UploadContext);
  //Anurag Declaration
  const apiUrl = process.env.REACT_APP_API_ENDPOINT;
  const [selectedFilter, setSelectedFilter] = useState("Sort By");
  const token = sessionStorage.getItem("number");
  const [errorMessage2, setErrorMessage2] = useState("");
  const [paginatedData, setPaginatedData] = useState([]);
  // const [currentPage, setCurrentPage] = useState(1);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(10);
  const [totalPages, settotalPages] = useState(0);
  const [filedata, setFileData] = useState([]);
  const [filedata2, setFileData2] = useState([]);
  const dispatch = useDispatch();
  const [onlyfolderlist, setOnlyFolderList] = useState([]);
  const [rootsize, setRootSize] = useState("");
  const [currentFile, setCurrentFile] = useState({});
  const [isProgressVisible, setIsProgressVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [showFTPopup, setShowFTPopup] = useState(false);
  const [imageSrc, setImageSrc] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [videoSrc, setVideoSrc] = useState("");
  const [isVideo, setisVideo] = useState(false);
  const [newFileName, setNewFileName] = useState("");
  const counter = useSelector((state) => state.getdata.counter);
  const select = useSelector((state) => state.getdata.userdata);
  const isSharedValue = useSelector((state) => state.getdata.isSharedValue);
  const filenameRedux = useSelector((state) => state.getdata.fileName);
  // console.log("User Data:", userdata);
  // console.log("Shared Value:", isSharedValue);
  // console.log("shared folder name is :", filenameRedux);

  const selectedItem = select.find((item) => item.id === counter);
  const nav = useNavigate();
  const navigate = useNavigate();
  const responseData = selectedItem ? selectedItem.Files : [];
  const isShared = selectedItem ? selectedItem.isShared : false;
  const [pdfSrc, setPdfSrc] = useState("");
  const [pubpri2, setPubPri2] = useState("private");
  const [pubpri3, setPubPri3] = useState("private");
  const newPath = useSelector((state) => state.getdata.folderName);
  const [query, setQuery] = useState("");
  const [folderList, setFolderList] = useState([]);
  const [nameOfFolder, setNameOfFolder] = useState("");
  const [isVisibility, setIsVisibility] = useState(false);
  const [visiKey, setVisiKey] = useState("");
  const [infoShower, setInfoShower] = useState(false);
  const [modalFile, setModalFile] = useState("");
  const [folderFieldError, setFolderFieldError] = useState("");
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [dragPop, setDragPop] = useState(false);
  const [dragFile, setDragFile] = useState({});
  const [targetFolder, setTargetFolder] = useState("");
  // console.log("Get Is Shared value :", getIsShared)

  const [fileInfo, setFileInfo] = useState({
    fileName: "",
    fileSize: "",
    fileType: "",
    fileUrl: "",
    uploadDateTime: "",
    fileIcon: "",
  });
  const [show, setShow] = useState(false);
  const [showImage, setShowImage] = useState(false);

  useEffect(() => {
    const lockScroll = () => {
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
    };

    const unlockScroll = () => {
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
    };

    if (showImage) {
      lockScroll();
    } else {
      unlockScroll();
    }

    return () => unlockScroll(); // cleanup
  }, [showImage]);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalEntries, setTotalEntries] = useState(0);
  const [allData, setAllData] = useState([]);
  // const [fileData, setFileData] = useState([]);

  const totalPageCount = Math.ceil(totalEntries / itemsPerPage);
  const isNextPage = currentPage < totalPageCount;
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalEntries);
  const [view, setView] = useState(localStorage.getItem("view") || "list");

  const toggleView = (selectedView) => {
    setView(selectedView);
    localStorage.setItem("view", selectedView); // Save selection in localStorage
  };

  useEffect(() => {
    // Initial data load
    getFolderFiles(selectedFolder);
  }, [selectedFolder]);

  // Fetch all folder files

  const getFolderFiles = async (foldername, size) => {
    try {
      const cleanfoldername = foldername.fileName;
      // console.log("cleanfoldername", cleanfoldername);
      // console.log("isSharedValue", isSharedValue);
      // console.log("filenameRedux", filenameRedux);

      // Prepare API parameters based on isSharedValue
      const params = isSharedValue
        ? {
            folderPath: cleanfoldername,
            shared: filenameRedux,
          }
        : {
            folderPath: cleanfoldername,
          };

      // Make API call with the correct parameters
      const res = await axios.get(`${apiUrl}getFolder`, {
        params,
        headers: { Authorization: `Bearer ${token}` },
      });

      // Update state
      setAllData(res.data);
      setTotalEntries(res.data.length);
      setCurrentPage(1);
      setFileData(res.data.slice(0, itemsPerPage));

      // Navigate and update store
      nav(`/nested/${counter + 1}`, { state: { value: size } });
      dispatch(
        addToken({
          id: counter + 1,
          Files: res.data,
        })
      );
      dispatch(incrementCounter());
    } catch (error) {
      // console.error(`There's an error: ${error}`);
      // console.log("error:", error.response?.data?.error);

      if (error.response?.data?.error === "jwt expired") {
        alert("Session expired. Please login again.");
        setTimeout(() => {
          nav("/Login");
        }, 0);
      }

      if (error.response && error.response.status === 500) {
        window.alert("Unable to retrieve folder contents.");
      }
    }
  };

  // Handle pagination
  const goToFirstPage = () => {
    setCurrentPage(1);
    setFileData(allData.slice(0, itemsPerPage));
  };

  const goToPrevPage = () => {
    if (currentPage > 1) {
      const newPage = currentPage - 1;
      setCurrentPage(newPage);
      setFileData(
        allData.slice((newPage - 1) * itemsPerPage, newPage * itemsPerPage)
      );
    }
  };

  const goToNextPage = () => {
    if (currentPage < totalPageCount) {
      const newPage = currentPage + 1;
      setCurrentPage(newPage);
      setFileData(
        allData.slice((newPage - 1) * itemsPerPage, newPage * itemsPerPage)
      );
    }
  };

  const goToLastPage = () => {
    if (currentPage < totalPageCount) {
      setCurrentPage(totalPageCount);
      setFileData(
        allData.slice(
          (totalPageCount - 1) * itemsPerPage,
          totalPageCount * itemsPerPage
        )
      );
    }
  };

  // Handle items per page change
  const handleItemsPerPageChange = (e) => {
    const newItemsPerPage = parseInt(e.target.value, 10);
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1); // Reset to page 1
    setFileData(allData.slice(0, newItemsPerPage)); // Load new first page
  };

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  const handleImageShow = () => setShowImage(true);
  const handleImageClose = () => {
    // console.log("Close button clicked!");

    // Exit fullscreen if currently in fullscreen mode
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }

    setIsFullscreen(false); // Reset fullscreen state
    setZoomLevel(1); // Reset zoom level to default
    setShowImage(false);
    setCurrentImageIndex(0);
    setImageSrc("");
    setVideoSrc("");
    setAudioSrc("");
    setPdfSrc("");
  };
  const location = useLocation();
  const value = location.state?.value;

  const [downloadPopup, setDownloadpopup] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [loading, isSetLoading] = useState(false);
  const cancelToken = useRef(null);
  const [downloadLink, setDownloadLink] = useState(null);

  const [sharePopup, setSharepopup] = useState(false);
  const [shareLink, setShareLink] = useState("");

  const [keys, setKeys] = useState([]);
  const [keys2, setKeys2] = useState([]);
  const [selectStatus, setSelectStatus] = useState(false);

  // console.log("responseData", responseData, isShared);
  // console.log("select", select);

  //Anurag Code
  const navigationType = useNavigationType();
  const location2 = useLocation();
  const previousLocationRef = useRef(location2);

  const [isWhisperClicked, setIsWhisperClicked] = useState(false);
  const [movedFile, setMovedFile] = useState("");

  const [isCWhisperClicked, setIsCWhisperClicked] = useState(false);
  const [copiedFile, setCopiedFile] = useState("");

  const [audioSrc, setAudioSrc] = useState("");
  const [isAudio, setIsAudio] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const [moveFol, setMoveFol] = useState(false);
  const [movedFol, setMovedFol] = useState("");
  const fileTypes = ["pdf", "jpg", "jpeg", "png", "mov", "mp3", "mp4", "webp"];
  const [selectedFileTypes, setSelectedFileTypes] = useState([]);

  const handleMClick = (name) => {
    setIsWhisperClicked(true);
    setMovedFile(name);
  };

  const handleMClose = () => {
    setIsWhisperClicked(!isWhisperClicked);
    setKeys([]);
    setKeys2([]);
    dispatch(resetFolderList());
  };
  const handleMFClick = (name) => {
    setMoveFol(true);
    setMovedFol(name);
  };
  const handleMFClose = () => {
    setMoveFol(false);
    dispatch(resetFolderList());
  };

  // Copy File code
  const handleCClick = (name) => {
    setIsCWhisperClicked(true);
    setCopiedFile(name);
  };
  const handleCClose = () => {
    dispatch(resetFolderList());
    setIsCWhisperClicked(false);
    setKeys([]);
  };
  //Checkbox code
  const handleCheckboxChange = (file) => {
    if (file.isFolder === true) {
      // If the file is a folder, update the keys2 list
      setKeys2((prevKeys2) => {
        const isChecked = prevKeys2.includes(file.fileName);

        // Update the keys2 list for folders
        const newKeys2 = isChecked
          ? prevKeys2.filter((f) => f !== file.fileName)
          : [...prevKeys2, file.fileName];

        return newKeys2;
      });
    } else {
      // If the file is not a folder, update the keys list
      setKeys((prevKeys) => {
        const isChecked = prevKeys.includes(file.fileName);

        // Update the keys list for files
        const newKeys = isChecked
          ? prevKeys.filter((f) => f !== file.fileName)
          : [...prevKeys, file.fileName];

        return newKeys;
      });
    }
  };
  //Breadcrum Implementation
  const handleBreadClick = (event, part, index, len) => {
    // Prevent default behavior of <a> tag
    event.preventDefault();

    // console.log("jbjb", index, len);

    if (len === index + 2) {
      // console.log("Do nothing");
    } else {
      // console.log(`You clicked on: ${part} and ${index}`);
      dispatch(breadCrum({ number: index }));

      const navId = counter - (index + 1);
      // console.log("airtel", navId);

      navigate(-navId);
    }
  };
  const reduksData = useSelector((state) => state.getdata.userdata);
  // console.log("reduksData", reduksData);

  const [isSelectAll, setIsSelectAll] = useState(false);
  // Handle select/deselect all
  const handleSelectAllToggle = () => {
    if (!isSelectAll) {
      // Select all - preserve existing selections and add all other items
      const allFiles = paginatedData
        .filter((file) => !file.isFolder)
        .map((file) => file.fileName);
      const allFolders = paginatedData
        .filter((file) => file.isFolder)
        .map((file) => file.fileName);

      setKeys((prevKeys) => {
        const newKeys = [...new Set([...prevKeys, ...allFiles])];
        return newKeys;
      });

      setKeys2((prevKeys2) => {
        const newKeys2 = [...new Set([...prevKeys2, ...allFolders])];
        return newKeys2;
      });
    } else {
      // Deselect all
      setKeys([]);
      setKeys2([]);
      // console.log("arrays are", keys, keys2);
    }
    setIsSelectAll(!isSelectAll);
  };
  useEffect(() => {
    // console.log("Current arrays are:", keys, keys2);
  }, [keys, keys2]);

  const handleMulDelete = async () => {
    try {
      let params = {};
      if (isSharedValue) {
        params.shared = filenameRedux;
      }

      const filesToDelete = keys.length;
      const foldersToDelete = keys2.length;

      // Flags to track what was deleted
      let fileDeleted = false;
      let folderDeleted = false;

      // Delete files
      if (filesToDelete > 0) {
        await axios.delete(`${apiUrl}delete-file`, {
          data: { keys },
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          params,
        });
        fileDeleted = true;
      }

      // Delete folders
      if (foldersToDelete > 0) {
        await axios.delete(`${apiUrl}delete-folder`, {
          data: { folderName: keys2 },
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          params,
        });
        folderDeleted = true;
      }

      // Show appropriate toast message
      if (fileDeleted && !folderDeleted) {
        showToast(
          "success",
          filesToDelete === 1
            ? "File deleted Successfully!"
            : "Files deleted Successfully!"
        );
      } else if (!fileDeleted && folderDeleted) {
        showToast(
          "success",
          foldersToDelete === 1
            ? "Folder deleted Successfully!"
            : "Folders deleted Successfully!"
        );
      } else if (fileDeleted && folderDeleted) {
        const fileLabel = filesToDelete === 1 ? "File" : "Files";
        const folderLabel = foldersToDelete === 1 ? "Folder" : "Folders";
        showToast(
          "success",
          `${fileLabel} and ${folderLabel} deleted Successfully!`
        );
      }

      // Reset state
      setIsSelectAll(false);
      setSelectStatus(false);
      reloadAfterTast();
      setKeys([]);
      setKeys2([]);
    } catch (error) {
      showToast("error", "Some error has occurred");
    }
  };

  useEffect(() => {
    reloadAfterTast();
  }, [isWhisperClicked, moveFol]);

  useEffect(() => {
    // console.log("Value of counter is", counter);
    setFilteredFileData(responseData, setFileData, counter);
  }, [counter]);

  const setFilteredFileData = (responseData, setFileData) => {
    const newRecords = responseData.length > 0 ? [...responseData] : [];

    setFileData(newRecords);
    settotalPages(Math.ceil(responseData.length / endIndex));
    const totalEntries = responseData.length;
  };
  useEffect(() => {
    const itemsPerPage = endIndex;
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endSliceIndex = startIndex + itemsPerPage;

    setPaginatedData(filedata.slice(startIndex, endSliceIndex));
  }, [filedata, currentPage, endIndex, refreshKey]); // Add refreshKey

  const getFileTypeIcon = (fileType) => {
    switch (fileType) {
      case "zip":
        return IconZip;
      case "jfif":
        return IconJfif;
      case "jpg":
        return IconJPG;
      case "png":
        return IconPNG;
      case "msi":
        return IconMsi;
      case "jpeg":
        return IconJpeg;
      case "pdf":
        return IconPDF;
      default:
        return IconFolder;
    }
  };

  const applyFilter = async () => {
    clearSearchBar();
    if (selectedFileTypes.length === 0) {
      closePopup(); // No filters → reload and close
      return;
    }

    try {
      const params = {
        fileTypes: selectedFileTypes.join(","),
      };

      let normalizedPath = path.replace(/\/$/, "").trim();
      const normalizedFilenameRedux = filenameRedux.trim();
      let apiEndpoint = `${apiUrl}getFolder`;

      if (isSharedValue) {
        if (normalizedPath === normalizedFilenameRedux) {
          apiEndpoint = `${apiUrl}get-all-files`;
        }
        params.shared = filenameRedux;
        if (normalizedPath !== normalizedFilenameRedux) {
          params.folderPath = normalizedPath
            .replace(`${normalizedFilenameRedux}/`, "")
            .replace(/\/$/, "");
          params.page = 1;
        }
      } else {
        params.folderPath = normalizedPath.replace(/\/$/, "");
        if (normalizedPath !== normalizedFilenameRedux) {
          params.page = 1;
        }
      }

      const response = await axios.get(apiEndpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params,
      });

      settotalPages(1);
      setPaginatedData(response.data);
    } catch (error) {
      console.error(`There's an error: ${error}`);
    }

    closeOnlyPopup(); // 👈 Don't reset selection or reload here
  };

  const handleFTCheckboxChange = (fileType) => {
    setSelectedFileTypes(
      (prevSelected) =>
        prevSelected.includes(fileType)
          ? prevSelected.filter((type) => type !== fileType) // Remove if already selected
          : [...prevSelected, fileType] // Add if not selected
    );
  };

  const handleFTypeSelect = (eventKey) => {
    // console.log("Filter selected !", eventKey);
    if (eventKey === "File Type") {
      // console.log("Something...");
      clearSearchBar();
      setShowFTPopup(true);
    }
  };

  const handleFilterSelect = (eventKey) => {
    // console.log("Filter selected !", eventKey);
    if (eventKey === "name-filter1") {
      setSelectedFilter("By Name(A-Z)");
      nameFilter1();
    } else if (eventKey === "name-filter2") {
      setSelectedFilter("By Name(Z-A)");
      nameFilter2();
    } else if (eventKey === "size-filter1") {
      setSelectedFilter("By Size(Asc)");
      sizeFilter1();
    } else if (eventKey === "size-filter2") {
      setSelectedFilter("By Size(Desc)");
      sizeFilter2();
    } else if (eventKey === "date-filter1") {
      setSelectedFilter("By Date(Oldest)");
      dateFilter1();
    } else if (eventKey === "date-filter2") {
      setSelectedFilter("By Date(Newest)");
      dateFilter2();
    }
  };
  const clearSearchBar = () => {
    setQuery("");
  };

  const fetchFilteredData = async (filterParams) => {
    try {
      let params = { ...filterParams };

      // Normalize path (remove trailing slash and trim spaces)
      let normalizedPath = path.replace(/\/$/, "").trim();
      let apiEndpoint = "getFolder"; // Default API

      if (isSharedValue) {
        params.shared = filenameRedux; // Add shared param if isShared is true

        if (normalizedPath === filenameRedux) {
          // If it's the root folder, switch API to get-all-files
          apiEndpoint = "get-all-files";
          delete params.folderPath; // Remove folderPath from payload
        } else {
          // Remove filenameRedux from folderPath when nested & ensure correct format
          params.folderPath = normalizedPath
            .replace(`${filenameRedux}/`, "") // Remove root folder prefix
            .replace(/\/$/, "") // Remove trailing slash
            .trim();
        }
      } else {
        params.folderPath = normalizedPath.replace(/\/$/, "").trim(); // Remove trailing slash for non-shared cases
      }

      const res = await axios.get(`${apiUrl}${apiEndpoint}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: params, // Pass dynamic parameters
      });

      setPaginatedData(res.data);
      settotalPages(1);
    } catch (error) {
      console.error(`There's an error: ${error}`);
    }
  };

  // Name Filters
  const nameFilter1 = () => fetchFilteredData({ ascending: true });
  const nameFilter2 = () => fetchFilteredData({ ascending: false });

  // Size Filters
  const sizeFilter1 = () => fetchFilteredData({ sortSize: true });
  const sizeFilter2 = () => fetchFilteredData({ sortSize: false });

  // Date Filters
  const dateFilter1 = () => fetchFilteredData({ sortByDate: "asc" });
  const dateFilter2 = () => fetchFilteredData({ sortByDate: "desc" });

  const closePopup = () => {
    setSelectedFileTypes([]); // 👈 Clear all selected file types
    reloadAfterTast();
    setShowFTPopup(false);
  };

  const closeOnlyPopup = () => {
    setShowFTPopup(false); // Just close modal
  };

  //Anurag Check Folder or File
  const chkFileorFolder = (file, size) => {
    if (
      file?.isFolder === "true" ||
      file?.isFolder === true ||
      file.fileType === "Folder"
    ) {
      // console.log("Nestedfile.fileName", file.fileName);

      const updatedFileName = isSharedValue
        ? `${filenameRedux}/${file.fileName}`
        : file.fileName;

      dispatch(
        setFolderPath({
          folderPath: updatedFileName + "/",
        })
      );

      getFolderFiles(file, size);
    } else {
      // console.log("Its a file.");

      openFile(file);
    }
  };
  //Anurag get into folder
  // const getFolderFiles = async (foldername, size) => {
  //   try {
  //     const cleanfoldername = foldername.fileName;
  //     console.log("clean folder name", cleanfoldername);

  //     const res = await axios.get(`${apiUrl}getFolder`, {
  //       params: {
  //         folderPath: cleanfoldername,
  //       },

  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });
  //     console.log("Response data is", res.data);

  //     nav(`/nested/${counter + 1}`, { state: { value: size } });
  //     dispatch(
  //       addToken({
  //         id: counter + 1,
  //         Files: res.data,
  //       })
  //     );
  //     dispatch(incrementCounter());
  //   } catch (error) {
  //     console.error(`There's error at ${error}`);
  //   }
  // };

  const getLastSegment = (path) => {
    // Split the path by slashes
    const parts = path.split("/");

    // Return the last segment
    return parts[parts.length - 1];
  };

  function getFileNameWithoutExtension(fileName) {
    const lastDotIndex = fileName.lastIndexOf(".");

    if (lastDotIndex !== -1) {
      // If a dot is found, return the file name without the extension
      return fileName.substring(0, lastDotIndex);
    } else {
      // If no dot is found, return the entire name (assuming it's a folder)
      return fileName;
    }
  }

  const removeSlash2 = (filename) => {
    // Split the filename by slashes
    const parts = filename.split("/");

    // Check if there is at least one slash
    if (parts.length > 1) {
      // Join everything after the first slash
      return parts.slice(1).join("/");
    } else {
      // If there are no slashes, return the original filename
      return filename;
    }
  };
  //Anurag handle Lightbox close
  const handleLightboxClose = () => {
    setIsOpen(false);
    setisVideo("");
    setImageSrc("");
    setAudioSrc("");
    setIsAudio(false);
  };
  //Anurag extract first part of the file
  const extractFirstPart = (str) => {
    const index = str.indexOf("/");
    if (index === -1) {
      // Return the whole string if there's no slash
      return str;
    }
    return str.substring(0, index);
  };

  //Image getting function
  const getImageInfo = async (filename) => {
    // console.log("Loader start");
    setIsProgressVisible(true);
    try {
      const params = {
        filePath: filename,
      };

      // Add shared parameter if isSharedValue is true
      if (isSharedValue) {
        params.shared = filenameRedux;
      }

      const res = await axios.get(`${apiUrl}getFile`, {
        params: params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "arraybuffer",
      });

      setIsProgressVisible(false);
      // console.log("Loader End");
      const base64Image = arrayBufferToBase64(res.data);
      const fileType = res.headers["content-type"];
      setImageSrc(`data:${fileType};base64,${base64Image}`);
    } catch (error) {
      console.error(error);
    }
  };
  //Audio getting function
  // Audio getting function
  const getAudioInfo = async (filename) => {
    try {
      const params = {
        filePath: filename,
      };

      if (isSharedValue) {
        params.shared = filenameRedux;
      }
      setIsProgressVisible(true);

      const res = await axios.get(`${apiUrl}getFile`, {
        params: params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "arraybuffer",
      });
      setIsProgressVisible(false);
      const fileType = res.headers["content-type"];
      const blob = new Blob([res.data], { type: fileType });
      const url = window.URL.createObjectURL(blob);
      setAudioSrc(url);
    } catch (error) {
      console.error(error);
    }
  };

  // Pdf getting function
  const getPdfInfo = async (filename) => {
    try {
      const params = {
        filePath: filename,
      };

      if (isSharedValue) {
        params.shared = filenameRedux;
      }
      setIsProgressVisible(true);

      const res = await axios.get(`${apiUrl}getFile`, {
        params: params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "arraybuffer",
      });
      setIsProgressVisible(false);
      const fileType = res.headers["content-type"];
      const blob = new Blob([res.data], { type: fileType });
      const url = window.URL.createObjectURL(blob);
      setPdfSrc(url);
    } catch (error) {
      console.error(error);
    }
  };

  // Anurag View Image, Video
  const openFile = async (file) => {
    try {
      const params = {
        filePath: file.fileName,
      };

      if (isSharedValue) {
        params.shared = filenameRedux;
      }

      const res = await axios.get(`${apiUrl}getFile`, {
        params: params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "arraybuffer",
      });
      const exactFile = removeSlash2(file.fileName);
      const fileType = res.headers["content-type"];
      setCurrentFile(fileTypeExtractor(fileType));

      const blob = new Blob([res.data], { type: fileType });
      const url = window.URL.createObjectURL(blob);
      // console.log(fileType);
      if (fileType === "application/zip") {
        // console.log("Handling zip...");
      } else if (extractFirstPart(fileType) === "video") {
        // console.log("Handling video...");
        if (fileType === "video/mkv") {
          setErrorMessage(
            "This video format is not supported by your browser."
          );
        } else {
          setIsOpen(!isOpen);
          setVideoSrc(url);
          setisVideo(true);
        }
      } else if (fileType === "application/pdf") {
        // console.log("Handling pdf...");
        setOpenPDFModal(true);
        setPdfSrc(url);
        // console.log(pdfSrc);
      } else if (extractFirstPart(fileType) === "image") {
        // console.log("Handling image...");
        setIsOpen(!isOpen);
        const base64Image = arrayBufferToBase64(res.data);
        setImageSrc(`data:${fileType};base64,${base64Image}`);
      } else if (extractFirstPart(fileType) === "audio") {
        setIsAudio(true);
        // console.log("Handling audio...");
        setAudioSrc(url);
      } else if (extractFirstPart(fileType) === "text") {
        // console.log("Handling text file...");
        setOpenPDFModal(true);
        setPdfSrc(url);
        // console.log(pdfSrc);
      }
    } catch (error) {
      // console.error("Error fetching file:", error);
    } finally {
    }
  };
  function arrayBufferToBase64(buffer) {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }
  const fileTypeExtractor = (file) => {
    const partBeforeSlash = file.split("/")[0];
    return partBeforeSlash;
  };

  useEffect(() => {
    return () => {
      if (audioSrc) {
        URL.revokeObjectURL(audioSrc);
      }
    };
  }, [audioSrc]);
  const audioFalse = () => {
    setIsAudio(false);
    setAudioSrc("");
  };
  const data = ["10", "25", "50", "100"].map((item) => ({
    label: item,
    value: Number(item),
  }));

  const pageFilter = (selectedValue) => {
    setItemsPerPage(selectedValue);
    setEndIndex(selectedValue);
    // Reset to first page when changing items per page
    setCurrentPage(1);
  };

  const [openFileUploadModal, setOpenFileUploadModal] = useState(false);
  const [createFolderButton, setCreateFolderButton] = useState(false);

  // Functions to handle modal visibility
  const handleOpenFileUploadModal = () => setOpenFileUploadModal(true);
  const handleCloseFileUploadModal = () => setOpenFileUploadModal(false);

  const handleOpenCreateFolder = () => setCreateFolderButton(true);
  const handleCloseCreateFolder = () => {
    setCreateFolderButton(false);
    setFolderFieldError("");
  };

  const [isLoading, setLoading] = useState(true); // State to manage loading state
  useEffect(() => {
    // Simulate an API call or data loading delay
    setTimeout(() => setLoading(false), 300); // Simulate 2 seconds loading time
  }, []);

  // INPUT VALUE
  // INPUT VALUE
  const [inputValue, setInputValue] = useState("");
  const handleInputChange = (e) => setInputValue(e.target.value);

  //POPOVER WITH TABLE ROW ACTIVE
  const [activeRow, setActiveRow] = useState(null);
  const [wholeFile, setWholeFile] = useState(null);

  const [renamePop, setRenamepop] = useState(false);
  const [extension, setExtension] = useState("");
  const handleOpenPopover = (file) => {
    // console.log("here are filke detailskjabslfbajs", file);
    setWholeFile(file);
    setNewFileName(file.fileName);
    setActiveRow(file.fileName);
    if (file.isFolder) {
      setInputValue(checkLastHash(file.fileName));
      // console.log(checkLastHash(file.fileName));
    } else {
      setInputValue(checkLastHash(getFileNameWithoutExtension(file.fileName)));
      setExtension(file.fileName.substring(file.fileName.lastIndexOf(".")));
    }
    setRenamepop(true);
  };

  const handleClosePopover = () => {
    setActiveRow(null);
    setRenamepop(false);
  };

  function removeSlashAndExtension(filePath) {
    // Extract the filename by removing everything before the last slash
    const fileName = filePath.substring(filePath.lastIndexOf("/") + 1);

    // Remove the extension after the last dot
    return fileName.substring(0, fileName.lastIndexOf(".")) || fileName;
  }
  function removeSlash(filePath) {
    // Extract the filename by removing everything before the last slash
    return filePath.substring(filePath.lastIndexOf("/") + 1);
  }

  //Check last /
  const checkLastHash = (name) => {
    // Remove trailing slash if present
    if (name.endsWith("/")) {
      name = name.slice(0, -1);
    }

    // Split the string by slashes and return the last part
    const parts = name.split("/");
    return parts[parts.length - 1]; // Return the text after the last slash
  };

  //Rename Api call
  const handleRadioChange = (event) => {
    setPubPri2(event.target.value);
  };
  const handleRadioChange2 = (event) => {
    setPubPri3(event.target.value);
  };
  const [isRenaming, setIsRenaming] = useState(false);

  const handleFileRename = async (oldkey, newkey, file) => {
    if (isRenaming) return; // Prevent multiple clicks
    setIsRenaming(true);

    const queryParams = isSharedValue ? { shared: filenameRedux } : {};

    if (oldkey.includes(".")) {
      try {
        // File logic
        const lastSlashIndex = oldkey.lastIndexOf("/");
        const filePath = oldkey.substring(0, lastSlashIndex + 1);
        const fileExtension = oldkey.substring(oldkey.lastIndexOf("."));
        const updatedNewKey = `${filePath}${newkey}${fileExtension}`;

        await axios.post(
          `${apiUrl}rename-file`,
          {
            oldKey: oldkey,
            newKey: updatedNewKey,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            params: queryParams,
          }
        );

        showToast("success", "File renamed successfully!");
        setExtension("");
        reloadAfterTast();
        handleClosePopover();
      } catch (error) {
        showToast("error", `There's an error while renaming file!`);
      } finally {
        setIsRenaming(false);
      }
    } else {
      try {
        // Folder logic
        const updatedNewKey = `${oldkey.substring(
          0,
          oldkey.lastIndexOf("/") + 1
        )}${newkey}`;

        await axios.post(
          `${apiUrl}rename-folder`,
          {
            oldFolderName: oldkey,
            newFolderName: updatedNewKey,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            params: queryParams,
          }
        );

        showToast("success", "Folder renamed successfully");
        reloadAfterTast();
        handleClosePopover();
      } catch (error) {
        showToast("error", `There's an error while renaming folder!`);
      } finally {
        setIsRenaming(false);
      }
    }
  };

  //Convert Visibility
  //Convert visibility
  const changeVisibility = (file) => {
    if (!pubpri2) {
      showToast("error", "Please select Public or Private before proceeding.");
      return;
    }

    const actualoperation = async () => {
      try {
        const queryParams = isSharedValue ? `?shared=${filenameRedux}` : "";
        const url = `${apiUrl}convert-visibility${queryParams}`;

        const res = await axios.post(
          url,
          {
            key: file,
            targetVisibility: pubpri2,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        // console.log(res.data);
        showToast("success", "Visibility has been changed!");
        setPubPri2("");
        setVisiKey("");
        setIsVisibility(false);
        reloadAfterTast();
      } catch (error) {
        console.error(`There's error at ${error}`);
        showToast("error", "Error while changing visibility!");
      }
    };

    actualoperation();
  };

  // DELETE POPOVER
  const [activeDeleteRow, setActiveDeleteRow] = useState(null);
  const [deletePop, setDeletepop] = useState(false);
  // Function to open delete popover
  const handleOpenDeletePopover = (id) => {
    setActiveDeleteRow(id);
    setDeletepop(true);
  };

  // Function to close delete popover
  const handleCloseDeletePopover = () => {
    setActiveDeleteRow(null);
    setDeletepop(false);
  };

  //Anurag  Delete File or Folder
  const handleFileDelete = async (file) => {
    // console.log("Started to delete files, folder...");
    //  console.log(file);

    const isShared = isSharedValue; // <- use your actual flag
    let apiEndpoint = file?.isFolder
      ? `${apiUrl}delete-folder`
      : `${apiUrl}delete-file`;

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": file?.isFolder
          ? "application/json"
          : "application/x-www-form-urlencoded",
      },
      ...(isShared && {
        params: { shared: filenameRedux },
      }),
    };

    try {
      if (file?.isFolder) {
        // console.log("folder", file);
        const res = await axios.delete(apiEndpoint, {
          ...config,
          data: { folderName: [file.fileName] },
        });
        showToast("success", "Folder deleted successfully!");
      } else {
        // console.log("file", file);
        const deleteKey = file.fileName;
        const res = await axios.delete(apiEndpoint, {
          ...config,
          data: { keys: [deleteKey] },
        });
        showToast("success", "File deleted successfully");
      }

      await reloadAfterTast(file?.isShared);
      handleCloseDeletePopover();
    } catch (error) {
      const errMsg = file?.isFolder
        ? "There's an error while deleting folder!"
        : "There's an error while deleting file!";
      showToast("error", errMsg);
    }
  };

  //Remove data from redux after back button clicked
  useEffect(() => {
    if (location2.pathname !== previousLocationRef.current.pathname) {
      if (navigationType === "POP") {
        // User clicked the back button
        // console.log("Back button was clicked");
        // Perform your desired action here

        dispatch(decrementCounter());
        dispatch(removeLastToken());
      }
      previousLocationRef.current = location2;
    }
  }, [location2, navigationType]);
  //Navigate to Files page when user clicks reload button

  useEffect(() => {
    if (sessionStorage.getItem("reloaded")) {
      navigate("/Files");
    } else {
      sessionStorage.setItem("reloaded", "true");
    }
    return () => {
      sessionStorage.removeItem("reloaded");
    };
  }, [navigate]);

  const [openPDFModal, setOpenPDFModal] = useState(false);
  const handleOpenPDFModal = () => setOpenPDFModal(true);
  const handleClosePDFModal = () => setOpenPDFModal(false);

  //Upload code starts here
  const [pubpri, setPubPri] = useState("private");
  const [files, setFiles] = useState([]);
  const [directory, setDirectory] = useState("");
  const [fileList, setFileList] = useState([]);
  const [preLoader2, setPreLoader2] = useState(false);
  const [folderStructure, setFolderStructure] = useState({});
  const t = useSelector((state) => state.getdata.folderName);
  // console.log("t", t);

  const getUcer = (file, counter) => {
    const parts = file.split("/");
    return parts.slice(0, counter).join("/") + "/";
  };
  // console.log("Counter for path is :", counter);
  if (counter > 0) {
    var path = getUcer(t, counter);
    // console.log("path will be", path);
  } else {
    path = "";
  }
  const secondPath = path;
  // console.log("secondPath", secondPath);
  const parts = secondPath.split("/");
  // console.log("parts", parts);

  const removeFile = (index) => {
    const updatedFiles = [...files];
    updatedFiles.splice(index, 1);
    setFiles(updatedFiles);
  };

  const handlePubChange = (event) => {
    setPubPri(event.target.value);
  };
  function getTextBeforeFirstSlash(text) {
    const indexOfFirstSlash = text.indexOf("/");
    if (indexOfFirstSlash !== -1) {
      return text.substring(0, indexOfFirstSlash);
    }
    return text; // Return the entire text if no slash is found
  }
  function getModifiedRecentFolderText(input) {
    const index = input.indexOf("/");
    if (index !== -1 && index < input.length - 1) {
      // Extract the substring after the first slash
      const textAfterSlash = input.substring(index + 1);
      // Replace all '/' with '<'
      return textAfterSlash.replace(/\//g, "<");
    } else {
      return "";
    }
  }

  const fileList2 = files.map((file, index) => (
    <li key={file.name}>
      <div>
        {file.type.startsWith("image/") ? (
          <div className="file_img">
            <img src={URL.createObjectURL(file)} alt={file.name} style={{}} />
          </div>
        ) : (
          <div>
            <i
              className="mdi mdi-file-document-box-multiple-outline"
              style={{ fontSize: "48px" }}
            ></i>
          </div>
        )}
        <div className="upload_file_content">
          <button onClick={() => removeFile(index)}>
            <i className="mdi mdi-close"></i>
          </button>
        </div>
      </div>
    </li>
  ));

  const sanitizeFilename = (filename, options = {}) => {
    // Default options
    const maxLength = options.maxLength || 50;
    
    // Handle empty or invalid input
    if (!filename || typeof filename !== 'string') {
      return 'unnamed_file';
    }
    
    // Check if file has an extension
    const lastDotIndex = filename.lastIndexOf('.');
    const hasExtension = lastDotIndex > 0 && lastDotIndex < filename.length - 1;
    
    // Extract extension and name parts
    let extension = '';
    let nameWithoutExt = filename;
    
    if (hasExtension) {
      extension = filename.substring(lastDotIndex + 1);
      nameWithoutExt = filename.substring(0, lastDotIndex);
    }
    
    // Extract season and episode info (like S01E02)
    const seasonEpisodeMatch = nameWithoutExt.match(/[sS]\d{1,2}[eE]\d{1,2}/);
    const seasonEpisode = seasonEpisodeMatch
      ? seasonEpisodeMatch[0].toUpperCase()
      : '';
    
    // Extract resolution info (like 1080p, 720p, 4K)
    const resolutionMatch = nameWithoutExt.match(/\b(1080p|720p|4[kK]|8[kK]|2160p|UHD)\b/i);
    const resolution = resolutionMatch ? resolutionMatch[0] : '';
    
    // Extract year in parentheses (like "(2023)")
    const yearMatch = nameWithoutExt.match(/\((\d{4})\)/);
    const year = yearMatch ? yearMatch[0] : '';
    
    // For numeric-only filenames, add a prefix
    let mainTitle = nameWithoutExt;
    if (/^\d+$/.test(mainTitle)) {
      mainTitle = `${mainTitle}`;
    }
    
    // Clean the main title - keep only alphanumeric, spaces, and some safe characters
    mainTitle = mainTitle
      .replace(/[sS]\d{1,2}[eE]\d{1,2}/g, ' ') // Remove season/episode pattern from title
      .replace(/\b(1080p|720p|4[kK]|8[kK]|2160p|UHD)\b/gi, ' ') // Remove resolution from title
      .replace(/\(\d{4}\)/g, ' ') // Remove year from title
      .replace(/[^\w\s.-]/g, ' ') // Replace unsafe chars with spaces
      .replace(/\s+/g, ' ') // Collapse multiple spaces
      .trim();
    
    // Handle purely numeric or empty titles after cleaning
    if (!mainTitle || /^\d+$/.test(mainTitle)) {
      mainTitle = `${mainTitle || nameWithoutExt || 'unnamed'}`;
    }
    
    // Truncate the main title if it's too long
    if (mainTitle.length > maxLength) {
      mainTitle = mainTitle.substring(0, maxLength);
    }
    
    // Build the final name with metadata in a consistent order
    let finalName = mainTitle;
    
    // Add year if present
    if (year) {
      finalName += ` ${year}`;
    }
    
    // Add season/episode if present
    if (seasonEpisode) {
      finalName += ` ${seasonEpisode}`;
    }
    
    // Add resolution if present
    if (resolution) {
      finalName += ` ${resolution}`;
    }
    
    // Replace spaces with underscores for a more URL-friendly name
    finalName = finalName.replace(/\s+/g, '_');
    
    // Ensure the filename doesn't start or end with special characters
    finalName = finalName.replace(/^[.-]+|[.-]+$/g, '');
    
    // Add the extension back if it exists
    if (extension) {
      finalName += `.${extension.toLowerCase()}`;
    }
    
    return finalName;
  };

  const isVideoFile = (filename) => {
    const videoExtensions = ["mp4", "mkv", "avi", "mov", "flv", "wmv", "webm"];
    const ext = filename.split(".").pop().toLowerCase();
    return videoExtensions.includes(ext);
  };

// const handleFileUpload = async () => {
//   if (files.length === 0) {
//     showToast("error", "Please select a file to upload.");
//     return;
//   }

//   setOpenFileUploadModal(false);
//   setPreLoader2(true);

//   try {
    

//     // Array to hold all file upload promises
//     const uploadPromises = files.map((file, i) => {
//       const finalName = isVideoFile(file.name)
//         ? sanitizeFilename(file.name)
//         : file.name;

//       const uploadId = Date.now() + i;
//       addUpload(uploadId, "Uploading " + finalName);

//       // Handle folder path logic
//       const rawPath = isSharedValue
//         ? path.startsWith(`${filenameRedux}/`) && path.split("/").length === 2
//           ? ""
//           : path.replace(`${filenameRedux}/`, "")
//         : path;

//       const folderPath = rawPath.replace(/\/$/, ""); // remove trailing slash

//       // Build the endpoint URL (only include shared parameter in URL if needed)
//       let endpoint = `${apiUrl}upload-file`;
//       const queryParams = [];
      
//       // Add shared query param if needed (keep this in URL)
//       if (isSharedValue) {
//         queryParams.push(`shared=${encodeURIComponent(filenameRedux)}`);
//       }

//       if (queryParams.length > 0) {
//         endpoint += `?${queryParams.join('&')}`;
//       }

     
//       const formData = new FormData();
//       formData.append("files", file);
//       formData.append("isPrivate", pubpri === "private" ? "private" : "public-read");
//       formData.append("storageClass", "STANDARD");
      
//       // Add folderPath to form data payload instead of URL
//       if (folderPath) {
//         formData.append("folderPath", folderPath);
//       }

//       // Individual file upload request
//       return axios
//         .post(endpoint, formData, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "multipart/form-data",
//           },
//           onUploadProgress: (progressEvent) => {
//             const totalLength = progressEvent.lengthComputable
//               ? progressEvent.total
//               : file.size;

//             if (totalLength) {
//               const progress = Math.round(
//                 (progressEvent.loaded * 100) / totalLength
//               );
//               // console.log(`Progress for ${finalName}: ${progress}%`);
//               updateUploadProgress(uploadId, progress);
//             }
//           },
//         })
//         .then((response) => {
//           // console.log(`Upload completed for ${finalName}:`, response.data);
//           removeUpload(uploadId);
//           setPubPri("private");
//           reloadAfterTast(isSharedValue);
//         })
//         .catch((error) => {
//           // console.error(`Upload failed for ${finalName}:`, error);
//           removeUpload(uploadId);
//           throw new Error(`Error uploading file: ${finalName} - ${error.message}`);
//         });
//     });

//     // Wait for all file uploads to complete
//     // console.log("Waiting for all uploads to complete...");
//     await Promise.all(uploadPromises);
    
//     // console.log("All files uploaded successfully!");
//     showToast("success", "Files uploaded successfully!");
//   } catch (error) {
//     console.error("Upload Error:", error);
//     showToast("error", error.message || "Error uploading files");
//   } finally {
//     setPreLoader2(false);
//     setFiles([]);
//   }
// };

const handleFileUpload = async () => {
  if (files.length === 0) {
    showToast("error", "Please select a file to upload.");
    return;
  }

  setOpenFileUploadModal(false);
  setPreLoader2(true);

  try {
    // Prepare metadata for all files
    const metadata = {
      files: files.map((file) => {
        const finalName = isVideoFile(file.name)
          ? sanitizeFilename(file.name)
          : file.name;

        const rawPath = isSharedValue
          ? path.startsWith(`${filenameRedux}/`) &&
            path.split("/").length === 2
            ? ""
            : path.replace(`${filenameRedux}/`, "")
          : path;

        const folderPath = rawPath.replace(/\/$/, ""); // remove trailing slash

        return {
          fileName: finalName,
          fileSize: file.size,
          folderPath: folderPath,
          acl: pubpri === "private" ? "private" : "public-read",
        };
      }),
    };

    // Add shared query param if needed
    let presignUrl = `${apiUrl}get-upload-url`;
    if (isSharedValue) {
      const queryParams = new URLSearchParams({ shared: filenameRedux });
      presignUrl += `?${queryParams.toString()}`;
    }

    // Request presigned URLs
    const presignedResponse = await axios.post(presignUrl, metadata, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const urls = presignedResponse.data?.data;

    if (!Array.isArray(urls) || urls.length !== files.length) {
      throw new Error("Mismatch between files and presigned URLs.");
    }

    // Upload each file using the corresponding presigned URL
    const uploadPromises = files.map(async (file, i) => {
      const finalName = isVideoFile(file.name)
        ? sanitizeFilename(file.name)
        : file.name;

      const renamedFile = new File([file], finalName, { type: file.type });

      const uploadId = Date.now() + i;
      addUpload(uploadId, "Uploading " + finalName);

      const presignedUrl = urls[i]?.url;
      if (!presignedUrl) throw new Error("Presigned URL missing for file");

      // Upload to S3
      await axios.put(presignedUrl, renamedFile, {
        headers: {
          "Content-Type": file.type,
        },
        onUploadProgress: (progressEvent) => {
          const totalLength = progressEvent.lengthComputable
            ? progressEvent.total
            : file.size;
          if (totalLength) {
            const progress = Math.round(
              (progressEvent.loaded * 100) / totalLength
            );
            updateUploadProgress(uploadId, progress);
          }
        },
      });

      setPubPri("private");
      removeUpload(uploadId);
      reloadAfterTast(isSharedValue);
    });

    await Promise.all(uploadPromises);

    showToast("success", "Files uploaded successfully!");
  } catch (error) {
    console.error("Upload Error:", error);
    showToast("error", "Error uploading files");
  } finally {
    setPreLoader2(false);
    setFiles([]);
  }
};

  //Anurag folder upload
  const handleFolderChange = (event) => {
    // console.log("Event", event);
    const files = event;
    const updatedFileList = [];
    const updatedFolderStructure = {};

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const relativePath = file.webkitRelativePath;

      // Separate the folder path and file name
      const folderPath = relativePath.substring(
        0,
        relativePath.lastIndexOf("/")
      );
      setNameOfFolder(folderPath);
      // Update the file list with the folder path and file
      updatedFileList.push({
        path: folderPath, // Only the folder path without the file name
        file: file,
      });

      // Update the folder structure without including the file name
      updatedFolderStructure[file.name] = folderPath;
    }

    setFileList(updatedFileList);
    setFolderStructure(updatedFolderStructure);

    if (updatedFileList.length > 0) {
      setDirectory(getTextBeforeFirstSlash(updatedFileList[0].path));
    }

    // console.log("Updated file list:", updatedFileList);
    // console.log("Folder structure:", updatedFolderStructure);
  };

  useEffect(() => {
    // console.log("fileList", fileList);
  }, [fileList]);
  function removeLastSlashAndText(inputString) {
    const lastSlashIndex = inputString.lastIndexOf("/");

    // If no slash is found, return the original string
    if (lastSlashIndex === -1) {
      return inputString;
    }

    return inputString.substring(0, lastSlashIndex);
  }
  function removeAfterLastSlash(text) {
    const lastSlashIndex = text.lastIndexOf("/");
    if (lastSlashIndex === -1) {
      return text; // Return the original text if no slash is found
    }
    return text.substring(0, lastSlashIndex + 1); // +1 includes the slash
  }
  //Upload folder2
  // const uploadFolder = async () => {
  //   const uploadId = Date.now(); // Unique ID
  //   try {
  //     const formData = new FormData();
  //     formData.append("folderStructure", JSON.stringify(folderStructure));
  //     formData.append("folderPath", `${removeLastSlashAndText(path)}`);
  //     formData.append("storageClass", "STANDARD_IA");
  //     formData.append("isPrivate", pubpri3);

  //     fileList.forEach((fileInfo) => {
  //       formData.append(
  //         "files",
  //         fileInfo.file,
  //         `${fileInfo.path}/${fileInfo.file.name}`
  //       );
  //     });

  //     // Set up upload state before starting
  //     setOpenFileUploadModal(false);
  //     addUpload(uploadId, "Uploading " + nameOfFolder);
  //     setFiles([]);

  //     const response = await axios.post(`${apiUrl}upload-folder`, formData, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         "Content-Type": "multipart/form-data",
  //       },
  //       onUploadProgress: (progressEvent) => {
  //         const totalLength = progressEvent.lengthComputable
  //           ? progressEvent.total
  //           : fileList.reduce((acc, fileInfo) => acc + fileInfo.file.size, 0);

  //         if (totalLength) {
  //           const progress = Math.round(
  //             (progressEvent.loaded * 100) / totalLength
  //           );
  //           updateUploadProgress(uploadId, progress);
  //         }
  //       },
  //     });

  //     // Ensure we got a successful response
  //     if (response.status === 200) {
  //       // Update state and UI
  //       setPubPri3("private");
  //       reloadAfterTast()
  //       showToast("success", "Folder uploaded successfully!");
  //       console.log("Folder uploaded successfully:", response.data);
  //     } else {
  //       throw new Error(`Unexpected response status: ${response.status}`);
  //     }
  //   } catch (error) {
  //     console.error("Upload error:", error);
  //     showToast("error", "Error uploading folder");
  //     // Ensure we update the progress to indicate failure
  //     updateUploadProgress(uploadId, -1); // -1 could indicate error state
  //   } finally {
  //     // Always clean up the upload state
  //     handleCloseFileUploadModal();
  //     setTimeout(() => removeUpload(uploadId), 1000); // Give UI time to update
  //   }
  // };

  const uploadFolder = async () => {
    if (files.length === 0) {
      showToast("error", "Please select files to upload.");
      return;
    }

    handleCloseFileUploadModal();

    try {
      const metadataFiles = files.map((file) => {
        const originalName = file.name;
        const sanitizedName = isVideoFile(originalName)
          ? sanitizeFilename(originalName)
          : originalName;
        const rawPath = isSharedValue
          ? path.startsWith(`${filenameRedux}/`) && path.split("/").length === 2
            ? ""
            : path.replace(`${filenameRedux}/`, "")
          : path;

        const fullPath = file.webkitRelativePath || file.name;
        const localPath =
          fullPath.substring(0, fullPath.lastIndexOf("/")) || "";
        const folderPath = rawPath.replace(/\/$/, ""); // remove trailing slash
        return {
          fileName: sanitizedName,
          fileSize: file.size,
          folderPath: folderPath, // Base folder path
          localPath,
          acl: pubpri === "private" ? "private" : "public-read",
        };
      });

      // 🔁 Step 1: Get presigned URLs in one call
      const presignedResponse = await axios.post(
        `${apiUrl}get-upload-url`,
        { files: metadataFiles },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const uploadUrls = presignedResponse.data.data;

      // 🔁 Step 2: Upload each file using its respective URL
      const uploadPromises = files.map((file, i) => {
        const uploadId = Date.now() + i;
        const sanitizedName = metadataFiles[i].fileName;
        const presignedUrl = uploadUrls[i]?.url;

        if (!presignedUrl) {
          throw new Error(`Presigned URL missing for file ${sanitizedName}`);
        }

        addUpload(uploadId, "Uploading " + sanitizedName);

        return axios
          .put(presignedUrl, file, {
            headers: {
              "Content-Type": file.type,
            },
            onUploadProgress: (progressEvent) => {
              const totalLength = progressEvent.lengthComputable
                ? progressEvent.total
                : file.size;

              if (totalLength) {
                const progress = Math.round(
                  (progressEvent.loaded * 100) / totalLength
                );
                updateUploadProgress(uploadId, progress);
              }
            },
          })
          .then(() => {
            removeUpload(uploadId);
          });
      });

      await Promise.all(uploadPromises);

      showToast("success", "Folder uploaded successfully!");
      setCurrentPage(1);
      setPubPri("private");
      reloadAfterTast(isSharedValue);
    } catch (error) {
      console.error("Upload Error:", error);
      showToast("error", "Error uploading folder");
    }

    setFiles([]);
  }; 

  useEffect(() => {
    // console.log("fileList", fileList);
  }, [fileList]);
  //Create Folder
  const createJustFolder = async (event) => {
    event.preventDefault();

    const folderInput = document.getElementById("folname").value;

    // Validation: Allow only letters, numbers, underscores, hyphens, and spaces
    const isValid = /^[a-zA-Z0-9_\- ]{1,}$/.test(folderInput);
    if (!isValid) {
      setFolderFieldError(
        "Folder name can only contain letters, numbers, underscores, hyphens, and spaces."
      );
      return;
    }

    if (folderInput) {
      let folderName = folderInput;

      // Handle nested folder creation for shared paths
      if (isSharedValue) {
        // Remove the root folder name (filenameRedux) from the current path
        const relativePath = path
          .replace(new RegExp(`^${filenameRedux}/`), "") // Remove root folder prefix
          .replace(/\/$/, "") // Remove trailing slash
          .replace(/\/+/g, "/"); // Replace multiple slashes with single slash

        // Construct folder name with relative path
        folderName = relativePath
          ? `${relativePath}/${folderInput}`
          : folderInput;
      } else {
        // For non-shared paths, keep existing logic
        folderName = path + folderInput;
      }

      // Final cleanup to remove multiple consecutive slashes
      folderName = folderName.replace(/\/+/g, "/");

      try {
        // Define API parameters
        let params = {};
        if (isSharedValue) {
          params.shared = filenameRedux;
        }

        const res = await axios.post(
          `${apiUrl}create-folder`,
          { folderName: folderName }, // Pass the adjusted folder name
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/x-www-form-urlencoded",
            },
            params: params, // Add shared param dynamically
          }
        );

        handleCloseCreateFolder();
        setOpenFileUploadModal(false);
        // console.log(res.data);
        showToast("success", "Folder created successfully!");
        reloadAfterTast();
      } catch (error) {
        console.error(`There's an error at ${error}`);
      }

      document.getElementById("folname").value = null;
    }
  };

  //upload folder bug
  const onDrop = useCallback(
    (acceptedFiles) => {
      setFiles(acceptedFiles);
      handleFolderChange(acceptedFiles);
    },
    [handleFolderChange]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    // This will attempt to get all files from a folder
    directory: true,
    // Disable click and keydown behavior
    noClick: true,
    noKeyboard: true,
  });

  const handleSelectFolder = () => {
    // Create an input element
    const input = document.createElement("input");
    input.type = "file";
    input.webkitdirectory = true;
    input.directory = true;
    input.multiple = true;

    input.onchange = (e) => {
      const files = Array.from(e.target.files);
      setFiles(files);
      handleFolderChange(files);
    };

    // Trigger the file input click
    input.click();
  };

  const filterAndPaginateData = (response, path, query) => {
    const filteredRecords = response.filter((record) => {
      const matchesPath = removeAfterLastSlash(record.fileName) === path;
      const matchesQuery = record.fileName
        .toLowerCase()
        .includes(query.toLowerCase());
      return matchesPath && matchesQuery;
    });

    setPaginatedData(filteredRecords);
  };

  // console.log("PaginatedData : ", paginatedData);

  useEffect(() => {
    filterAndPaginateData(responseData, path, query);
  }, [query]);
  const clearSearch = () => {
    setQuery("");
  };

  const reloadAfterTast = async () => {
    try {
      let adjustedFolderPath = path.replace(/\/+$/, ""); // Remove trailing slashes

      if (isSharedValue) {
        // Remove filenameRedux from the beginning of the path
        if (adjustedFolderPath.startsWith(`${filenameRedux}/`)) {
          adjustedFolderPath = adjustedFolderPath.replace(
            `${filenameRedux}/`,
            ""
          );
        } else if (adjustedFolderPath === filenameRedux) {
          adjustedFolderPath = ""; // Root of shared folder
        }

        const res = await axios.get(`${apiUrl}getFolder`, {
          params: {
            folderPath: adjustedFolderPath,
            shared: filenameRedux,
          },
          headers: { Authorization: `Bearer ${token}` },
        });

        setFileData(res.data);
        setRefreshKey((prevKey) => prevKey + 1);
        dispatch(
          replacelasttoken({
            id: counter,
            Files: res.data,
          })
        );
      } else {
        // Non-shared case (no need to modify path)
        const res = await axios.get(`${apiUrl}getFolder`, {
          params: { folderPath: adjustedFolderPath },
          headers: { Authorization: `Bearer ${token}` },
        });

        setFileData(res.data);
        setRefreshKey((prevKey) => prevKey + 1);
        dispatch(
          replacelasttoken({
            id: counter,
            Files: res.data,
          })
        );
      }
    } catch (error) {
      console.error(`Error: ${error}`);

      if (error.response?.status === 500) {
        window.alert("Your session has expired. Please log in again.");
        sessionStorage.clear();
        nav("/");
      } else {
        console.error(`Detailed error: ${error}`);
      }
    }
  };

  // useEffect(() => {
  //   console.log("Updated filteredFileData:", filteredFileData);
  // }, [filteredFileData]); // This will trigger whenever filteredFileData changes

  const downloadFile = (file) => {
    // console.log("Started to download...");
    setSelectedFile(file);
    setDownloadpopup(true);
  };
  const { addDownload, updateDownloadProgress, removeDownload } =
    useContext(DownloadContext);

  const handleConfirmDownload = async () => {
    if (!selectedFile) return;

    const fileName = selectedFile.fileName;
    const isFolder = selectedFile.isFolder;
    const downloadId = Date.now();
    const tokenSource = axios.CancelToken.source();

    // Add to context
    addDownload(downloadId, fileName, tokenSource);
    setDownloadpopup(false); // Close the initial popup immediately

    isSetLoading(true);
    setProgress(0);
    cancelToken.current = tokenSource;

    try {
      const endpoint = isFolder ? "download-folder" : "download-file";
      const params = {
        filePath: fileName,
        ...(isSharedValue && { shared: filenameRedux }),
      };

      const response = await fetch(
        `${apiUrl}${endpoint}?${new URLSearchParams(params)}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) throw new Error("Network response was not ok");

      const contentLength = response.headers.get("content-length");
      const fileType = response.headers.get("content-type");
      let loaded = 0;

      // Create a stream reader
      const reader = response.body.getReader();
      const chunks = [];

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        chunks.push(value);
        loaded += value.length;

        // Update progress if we know the total size
        if (contentLength) {
          const percentCompleted = Math.round((loaded / contentLength) * 100);
          setProgress(percentCompleted);
          updateDownloadProgress(downloadId, percentCompleted);
        } else {
          // Fallback progress for unknown size
          const percentCompleted = Math.min((progress || 0) + 1, 99);
          setProgress(percentCompleted);
          updateDownloadProgress(downloadId, percentCompleted);
        }
      }

      // Combine all chunks
      const blob = new Blob(chunks, { type: fileType });
      const url = URL.createObjectURL(blob);

      // Create and trigger download
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName + (isFolder ? ".zip" : ""); // Add .zip if folder
      document.body.appendChild(a);
      a.click();

      // Cleanup
      setTimeout(() => {
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        setProgress(100);
        updateDownloadProgress(downloadId, 100);
        isSetLoading(false);
        removeDownload(downloadId);
      }, 500);
    } catch (error) {
      if (error.name === "AbortError") {
        console.warn("Download canceled:", error.message);
      } else {
        console.error("Download error:", error);
        alert("Error downloading file. Please try again.");
      }
      isSetLoading(false);
      setProgress(0);
      removeDownload(downloadId);
    }
  };

  const handleCancelDownload = () => {
    if (cancelToken.current) {
      cancelToken.current.cancel("Download canceled by user.");
    }
    isSetLoading(false);
    setProgress(0);
    setDownloadpopup(false);
  };

  //Download File and Folder
  // const downloadFile = (file) => {
  //   console.log("started to download...")
  //   setDownloadpopup(true)
  //   if (file?.isFolder == true) {
  //     console.log("Its a folder.")

  //   }
  //   else {
  //     console.log("Its a file.")
  //     try {
  //       const getDownLink = async () => {
  //         const res = await axios.get(`${apiUrl}getFile`, {
  //           params: {
  //             filePath: file.fileName
  //           },
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //           },
  //           responseType: 'arraybuffer',
  //         });
  //         const exactFile = removeSlash2(file.fileName);
  //         const fileType = res.headers['content-type'];
  //         const blob = new Blob([res.data], { type: fileType });
  //         const url = window.URL.createObjectURL(blob);
  //         console.log(fileType)

  //         setDownloadLink({ url, name: exactFile });

  //       }
  //       getDownLink()

  //     }
  //     catch (error) {
  //       console.error('Error fetching file:', error);
  //     }
  //   }
  // }

  //File information shower
  const getFileInfo = async (name) => {
    try {
      const res = await axios.get(`${apiUrl}file-info`, {
        params: {
          filePath: name,
          ...(isSharedValue && { shared: filenameRedux }), // Conditionally add 'shared' param
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "application/json",
      });
      // console.log("File information is", res.data);
      let fileData = res.data;

      // If res.data is a string, parse it as JSON
      if (typeof res.data === "string") {
        fileData = JSON.parse(res.data);
      }

      // console.log("File information is", fileData);
      setFileInfo({
        fileName: fileData.filePath,
        fileSize: fileData.fileSize,
        fileType: fileData.fileType,
        uploadDateTime: fileData.uploadDateTime,
        fileUrl: fileData.url,
        fileIcon: fileData.icon,
      });
      // console.log(res.data.filePath);
      // console.log("File info", fileInfo);
    } catch (error) {
      // console.log(error);
      showToast("error", "Unable to show information!");
    }
  };

  const shareFile = (file) => {
    // console.log("started to download...");
    setSharepopup(true);
    setSelectedFile(file); // Save the file for when user clicks "Generate URL"

    if (file?.isFolder) {
      // console.log("It's a folder.");
    } else {
      // console.log("It's a file.");
    }
  };
  const [shareMode, setShareMode] = useState("permanent"); // or "limited"
  const [selectedTimeOption, setSelectedTimeOption] = useState("1 Min");

  // Optional: to support manual entry in future
  const [useManualEntry, setUseManualEntry] = useState(false);
  const [manualTimeValue, setManualTimeValue] = useState("");
  const [manualTimeUnit, setManualTimeUnit] = useState("Day"); // Day, Hour, Min

  const timeOptions = [
    "1 Min",
    "10 Min",
    "1 Hour",
    "10 Hours",
    "1 Day",
    "10 Days",
  ];

  const timeToSeconds = {
    "1 Min": 60,
    "10 Min": 600,
    "1 Hour": 3600,
    "10 Hours": 36000,
    "1 Day": 86400,
    "10 Days": 864000,
  };
  const toggleTimeUnit = () => {
    const units = ["Day", "Hour", "Min"];
    const currentIndex = units.indexOf(manualTimeUnit);
    const nextIndex = (currentIndex + 1) % units.length;
    setManualTimeUnit(units[nextIndex]);
  };

  const generateShareLink = async () => {
    if (!selectedFile) return;

    let timeInSeconds = null;
    if (shareMode === "limited") {
      timeInSeconds = timeToSeconds[selectedTimeOption] || null;
    }

    const rawFilePath = selectedFile.fileName;
    const encodedPath = encodeURIComponent(rawFilePath);

    const isLimited = shareMode === "limited";

    const params = {
      ...(isSharedValue && { shared: filenameRedux }),
      ...(isLimited
        ? {
            key: rawFilePath,
            ...(timeInSeconds && { signedTime: timeInSeconds }),
          }
        : { filePath: rawFilePath }),
    };

    const endpoint = isLimited ? `get-private-url` : "file-info";

    try {
      const res = await axios.get(`${apiUrl}${endpoint}`, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "json",
      });

      const url = res.data.url;
      setShareLink(url);
      // console.log("Generated URL:", url);

      await navigator.clipboard.writeText(url);
      showToast("success", "Copied to clipboard!");
      setSharepopup(false);

      return url;
    } catch (error) {
      // console.error("Error generating share link:", error);
      showToast("error", "Failed to generate or copy link!");
      return null;
    }
  };

  const handleGenerateAndCopy = async () => {
    await generateShareLink(); // all logic is now inside here
  };

  // Copy text to clipboard
  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(shareLink)
      .then(() => {
        showToast("success", "Copied to clipboard!");
        setSharepopup(false);
      })
      .catch((err) => {
        showToast("error", "Failed to copy!");
      });
  };

  const closeSharePopup = () => {
    setSharepopup(false);
    setShareLink("");
    setSelectedFile(null);
    setShareMode("permanent");
    setSelectedTimeOption("1 Min");
  };
  // Focus on manual input field when user clicks on it
  const focusManualInput = () => {
    setUseManualEntry(true);
  };

  // Focus on dropdown when user clicks on it
  const focusDropdown = () => {
    setUseManualEntry(false);
  };

  const [codePopup, setCodePopup] = useState(false);
  const [codeContent, setCodeContent] = useState("");
  const [codeLanguage, setCodeLanguage] = useState("javascript");
  const codeExtensions = [
    "js",
    "jsx",
    "ts",
    "tsx",
    "html",
    "css",
    "json",
    "py",
    "php",
    "cpp",
  ];

  const [isLoading1, setIsLoading1] = useState(false);
  const [codeChunks, setCodeChunks] = useState([]); // chunks of lines
  const [fullLines, setFullLines] = useState([]); // entire line array
  const [chunkSize] = useState(500); // lines per chunk
  const [hasMoreChunks, setHasMoreChunks] = useState(false);

  const previewCodeFile = async (file) => {
    try {
      setIsLoading1(true);
      setCodePopup(true); // Show popup immediately

      const res = await axios.get(`${apiUrl}getFile`, {
        params: { filePath: file.fileName },
        headers: { Authorization: `Bearer ${token}` },
        responseType: "text",
      });

      const ext = file.fileName.split(".").pop();
      const langMap = {
        js: "javascript",
        jsx: "jsx",
        ts: "typescript",
        tsx: "tsx",
        html: "html",
        css: "css",
        json: "json",
        py: "python",
        php: "php",
        cpp: "cpp",
      };
      setCodeLanguage(langMap[ext] || "text");

      const lines = res.data.split("\n");
      setFullLines(lines);
      setCodeChunks([lines.slice(0, chunkSize).join("\n")]);
      setHasMoreChunks(lines.length > chunkSize);
    } catch (error) {
      console.error("Error fetching file:", error);
    } finally {
      setIsLoading1(false);
    }
  };

  const handleScroll = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom && hasMoreChunks && !isLoading1) {
      setIsLoading1(true);

      setTimeout(() => {
        const currentLength = codeChunks.reduce(
          (acc, chunk) => acc + chunk.split("\n").length,
          0
        );
        const nextChunk = fullLines.slice(
          currentLength,
          currentLength + chunkSize
        );
        setCodeChunks((prev) => [...prev, nextChunk.join("\n")]);

        if (currentLength + chunkSize >= fullLines.length) {
          setHasMoreChunks(false);
        }

        setIsLoading1(false);
      }, 200); // simulate async delay
    }
  };

  const [showFolderModal, setShowFolderModal] = useState(false);
  const [currentFileToZip, setCurrentFileToZip] = useState(null);

  async function ZipFile(file) {
    setShowFolderModal(true);
    setCurrentFileToZip(file);
  }

  async function processZipFile(file, destinationPath = "") {
    const apiUrl1 = `${apiUrl}zip-object`;

    const requestData = {
      filePath: file.fileName,
      destinationPath, // Defaults to empty string if not provided
    };

    // console.log("Request data for zipping:", requestData);

    try {
      const response = await axios.post(apiUrl1, requestData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: isSharedValue ? { shared: filenameRedux } : {},
      });

      // console.log("Zip successful:", response.data);
      showToast("success", "File successfully zipped!");
    } catch (error) {
      console.error("Error zipping file:", error);
      showToast("error", "Failed to zip file.");
    }
  }

  const [showFolderModalUnZip, setShowFolderModalUnZip] = useState(false);
  const [currentFileToUnzip, setCurrentFileToUnzip] = useState(null);

  async function UnzipFile(file) {
    setShowFolderModalUnZip(true);
    setCurrentFileToUnzip(file);
  }

  async function processUnzipFile(file, destinationPath = "") {
    const apiUrl1 = `${apiUrl}-object`;

    const requestData = {
      filePath: file.fileName,
      destinationPath, // Default to empty string for root folder
    };

    try {
      const response = await axios.post(apiUrl1, requestData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: isSharedValue ? { shared: filenameRedux } : {},
      });

      // console.log("Unzip successful:", response.data);
      showToast("success", "File successfully unzipped!");
    } catch (error) {
      console.error("Error unzipping file:", error);
      showToast("error", "Failed to unzip file.");
    }
  }

  const customTruncateFileName = (name, maxLength) => {
    if (name.length > maxLength) {
      return `${name.substring(0, maxLength - 9)} of the ${name.substring(
        maxLength - 6,
        maxLength
      )}...`;
    }
    return name;
  };

  const toast = useToast();

  const showToast = (status, message) => {
    toast({
      title: `${status.charAt(0).toUpperCase() + status.slice(1)}`,
      description: message,
      status: status, // Set this to 'error' for a red-colored pop-up
      duration: 3000,
      isClosable: true,
    });
  };

  //Image slider functionality
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const zoomIn = () => setZoomLevel((prevZoom) => Math.min(prevZoom + 0.2, 3));
  const zoomOut = () => setZoomLevel((prevZoom) => Math.max(prevZoom - 0.2, 1));
  const toggleFullscreen = () => {
    const modalElement = document.getElementById("modal-container");

    if (!isFullscreen) {
      if (modalElement.requestFullscreen) {
        modalElement.requestFullscreen();
      } else if (modalElement.mozRequestFullScreen) {
        // Firefox
        modalElement.mozRequestFullScreen();
      } else if (modalElement.webkitRequestFullscreen) {
        // Chrome, Safari, and Opera
        modalElement.webkitRequestFullscreen();
      } else if (modalElement.msRequestFullscreen) {
        // IE/Edge
        modalElement.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        // Firefox
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        // Chrome, Safari, and Opera
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        // IE/Edge
        document.msExitFullscreen();
      }
    }

    setIsFullscreen((prev) => !prev);
  };

  const handleNext = () => {
    setErrorMessage2("");
    setIsProgressVisible(true);
    setCurrentImageIndex((prevIndex) => {
      let newIndex = (prevIndex + 1) % paginatedData.length;
      let fileType = paginatedData[newIndex].fileType;

      // Loop to find the next item that is a file (has a fileType)
      while (!fileType && paginatedData.length > 0) {
        newIndex = (newIndex + 1) % paginatedData.length;
        fileType = paginatedData[newIndex].fileType;
      }

      if (
        fileType === "mp3" ||
        fileType === "MP3" ||
        fileType === "wav" ||
        fileType === "WAV" ||
        fileType === "ogg" ||
        fileType === "OGG" ||
        fileType === "aac" ||
        fileType === "AAC"
      ) {
        setImageSrc("");
        setVideoSrc("");
        setPdfSrc("");
        getAudioInfo(filedata[newIndex].fileName);
        setModalFile(filedata[newIndex].fileName);
      } else if (
        fileType === "jpeg" ||
        fileType === "jpg" ||
        fileType === "png" ||
        fileType === "gif" ||
        fileType === "hevc" ||
        fileType === "heif" ||
        fileType === "JPEG" ||
        fileType === "JPG" ||
        fileType === "PNG" ||
        fileType === "GIF" ||
        fileType === "HEVC" ||
        fileType === "HEIF" ||
        fileType === "svg" ||
        fileType === "SVG" ||
        fileType === "webp" ||
        fileType === "WEBP"
      ) {
        setVideoSrc("");
        setAudioSrc("");
        setPdfSrc("");
        getImageInfo(filedata[newIndex].fileName);
        setModalFile(filedata[newIndex].fileName);
      } else if (
        fileType === "pdf" ||
        fileType === "PDF" ||
        fileType === "txt" ||
        fileType === "TXT"
      ) {
        setImageSrc("");
        setVideoSrc("");
        setAudioSrc("");
        getPdfInfo(filedata[newIndex].fileName);
        setModalFile(filedata[newIndex].fileName);
      } else if (
        fileType === "mkv" ||
        fileType === "mp4" ||
        fileType === "mov" ||
        fileType === "mpeg" ||
        fileType === "webm" ||
        fileType === "MOV"
      ) {
        setImageSrc("");
        setAudioSrc("");
        setPdfSrc("");
        setIsProgressVisible(false);
        setVideoSrc(filedata[newIndex].fileName);
        setModalFile(filedata[newIndex].fileName);
      } else {
        setImageSrc("");
        setAudioSrc("");
        setPdfSrc("");
        setVideoSrc("");
        setIsProgressVisible(false);
        setErrorMessage2("Unsupported file format");
        setModalFile(filedata[newIndex].fileName);
      }

      setZoomLevel(1);
      return newIndex;
    });
  };

  const handlePrev = () => {
    setErrorMessage2("");
    setIsProgressVisible(true);
    setCurrentImageIndex((prevIndex) => {
      let newIndex =
        (prevIndex - 1 + paginatedData.length) % paginatedData.length;
      let fileType = paginatedData[newIndex].fileType;

      // Loop to find the next item that is a file (has a fileType)
      while (!fileType && paginatedData.length > 0) {
        newIndex = (newIndex - 1 + paginatedData.length) % paginatedData.length;
        fileType = paginatedData[newIndex].fileType;
      }

      if (
        fileType === "mp3" ||
        fileType === "MP3" ||
        fileType === "wav" ||
        fileType === "WAV" ||
        fileType === "ogg" ||
        fileType === "OGG" ||
        fileType === "aac" ||
        fileType === "AAC"
      ) {
        setImageSrc("");
        setVideoSrc("");
        setPdfSrc("");
        getAudioInfo(filedata[newIndex].fileName);
        setModalFile(filedata[newIndex].fileName);
      } else if (
        fileType === "jpeg" ||
        fileType === "jpg" ||
        fileType === "png" ||
        fileType === "gif" ||
        fileType === "hevc" ||
        fileType === "heif" ||
        fileType === "JPEG" ||
        fileType === "JPG" ||
        fileType === "PNG" ||
        fileType === "GIF" ||
        fileType === "HEVC" ||
        fileType === "HEIF" ||
        fileType === "svg" ||
        fileType === "SVG" ||
        fileType === "webp" ||
        fileType === "WEBP"
      ) {
        setVideoSrc("");
        setAudioSrc("");
        setPdfSrc("");
        getImageInfo(filedata[newIndex].fileName);
        setModalFile(filedata[newIndex].fileName);
      } else if (
        fileType === "pdf" ||
        fileType === "PDF" ||
        fileType === "txt" ||
        fileType === "TXT"
      ) {
        setImageSrc("");
        setVideoSrc("");
        setAudioSrc("");
        getPdfInfo(filedata[newIndex].fileName);
        setModalFile(filedata[newIndex].fileName);
      } else if (
        fileType === "mkv" ||
        fileType === "mp4" ||
        fileType === "mov" ||
        fileType === "mpeg" ||
        fileType === "webm" ||
        fileType === "MOV"
      ) {
        setImageSrc("");
        setAudioSrc("");
        setPdfSrc("");
        setIsProgressVisible(false);
        setVideoSrc(filedata[newIndex].fileName);
        setModalFile(filedata[newIndex].fileName);
      } else {
        setImageSrc("");
        setAudioSrc("");
        setPdfSrc("");
        setVideoSrc("");
        setIsProgressVisible(false);
        setErrorMessage2("Unsupported file format");
        setModalFile(filedata[newIndex].fileName);
      }
      setZoomLevel(1);
      return newIndex;
    });
  };

  const deleteFromModal = async (filename) => {
    // console.log("Deleting file", filename);
    const dataToSend = {
      keys: [filename],
    };
    try {
      const res = await axios.delete(`${apiUrl}delete-file`, {
        data: dataToSend,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      async function executeFunctionsInOrder() {
        try {
          showToast("success", "File deleted successfully");

          await reloadAfterTast();

          handleNext();
        } catch (error) {
          console.error("Error executing functions:", error);
        }
      }

      executeFunctionsInOrder();
    } catch (error) {
      showToast("error", `There's an error while deleting file!`);
    }
  };

  useEffect(() => {
    // Function to handle keydown events
    const handleKeyDown = (event) => {
      if (showImage) {
        if (event.key === "ArrowLeft") {
          handlePrev(); // Trigger handlePrev when the left arrow key is pressed
        } else if (event.key === "ArrowRight") {
          handleNext(); // Trigger handleNext when the right arrow key is pressed
        }
      }
    };

    // Add the event listener when the component mounts
    window.addEventListener("keydown", handleKeyDown);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [showImage]);

  //Drag to move
  const [draggedItem, setDraggedItem] = useState(null);

  // Function called when dragging starts
  const handleDragStart = (e, file) => {
    setDraggedItem(file); // Keep track of the currently dragged item
    e.dataTransfer.effectAllowed = "move";

    const totalSelectedItems = keys.length + keys2.length;

    const dragPreview = document.createElement("div");
    dragPreview.style.width = "200px"; // Adjust the size as needed
    dragPreview.style.height = "auto"; // Let the height adjust based on content
    dragPreview.style.backgroundColor = "white";
    dragPreview.style.border = "1px solid #ccc";
    dragPreview.style.padding = "10px";
    dragPreview.style.boxShadow = "0 4px 10px rgba(0, 0, 0, 0.2)";
    dragPreview.style.display = "flex";
    dragPreview.style.flexDirection = "column";
    dragPreview.style.alignItems = "center";
    dragPreview.style.justifyContent = "flex-start"; // Align items to the start
    dragPreview.style.gap = "10px"; // Add space between the icon and file name
    dragPreview.style.opacity = "1";

    dragPreview.style.position = "absolute";
    dragPreview.style.top = "-1000px"; // Move it way offscreen
    dragPreview.style.left = "-1000px";

    // Add the selected items
    if (totalSelectedItems > 1) {
      keys.forEach((fileName) => {
        const fileContainer = document.createElement("div");
        fileContainer.style.display = "flex";
        fileContainer.style.alignItems = "center";
        fileContainer.style.gap = "5px"; // Space between icon and name
        fileContainer.style.transition = "all 0.3s ease"; // Smooth transition on hover

        const fileIcon = document.createElement("div"); // Custom icon element
        fileIcon.style.width = "24px";
        fileIcon.style.height = "24px";
        fileIcon.style.backgroundColor = "#ddd"; // Custom icon color
        fileIcon.style.borderRadius = "4px"; // Rounded corners
        fileIcon.style.display = "flex";
        fileIcon.style.alignItems = "center";
        fileIcon.style.justifyContent = "center";
        fileIcon.innerText = "F"; // Replace "F" with a custom symbol or icon

        const fileNameSpan = document.createElement("span");
        fileNameSpan.innerText = removeSlashAndExtension(fileName);
        fileNameSpan.style.fontSize = "14px";
        fileNameSpan.style.color = "#333";

        fileContainer.appendChild(fileIcon);
        fileContainer.appendChild(fileNameSpan);
        dragPreview.appendChild(fileContainer);

        // Apply the "dragging" style to each file container directly
        fileContainer.style.opacity = "1"; // Make sure it's fully visible
      });

      // Iterate over the keys2 array to add folder icons and names
      keys2.forEach((folderName) => {
        const folderContainer = document.createElement("div");
        folderContainer.style.display = "flex";
        folderContainer.style.alignItems = "center";
        folderContainer.style.gap = "5px"; // Space between icon and name
        folderContainer.style.transition = "all 0.3s ease"; // Smooth transition on hover

        const folderIcon = document.createElement("div"); // Folder icon element
        folderIcon.style.width = "24px";
        folderIcon.style.height = "24px";
        folderIcon.style.backgroundColor = "#ffcc00"; // Folder icon color
        folderIcon.style.borderRadius = "4px"; // Rounded corners
        folderIcon.style.display = "flex";
        folderIcon.style.alignItems = "center";
        folderIcon.style.justifyContent = "center";
        folderIcon.innerText = "📁"; // Folder emoji as an icon

        const folderNameSpan = document.createElement("span");
        folderNameSpan.innerText = removeSlashAndExtension(folderName);
        folderNameSpan.style.fontSize = "14px";
        folderNameSpan.style.color = "#333";

        folderContainer.appendChild(folderIcon);
        folderContainer.appendChild(folderNameSpan);
        dragPreview.appendChild(folderContainer);

        // Apply the "dragging" style to each folder container directly
        folderContainer.style.opacity = "1"; // Make sure it's fully visible
      });
    } else {
    }

    // Add the dragged item to the preview (whether it’s selected or not)
    const draggedItemContainer = document.createElement("div");
    draggedItemContainer.style.display = "flex";
    draggedItemContainer.style.alignItems = "center";
    draggedItemContainer.style.gap = "5px"; // Space between icon and name
    draggedItemContainer.style.transition = "all 0.3s ease"; // Smooth transition on hover

    const draggedItemIcon = document.createElement("div"); // Custom icon element for dragged item
    draggedItemIcon.style.width = "24px";
    draggedItemIcon.style.height = "24px";
    draggedItemIcon.style.backgroundColor = "#4caf50"; // Different color for dragged item
    draggedItemIcon.style.borderRadius = "4px"; // Rounded corners
    draggedItemIcon.style.display = "flex";
    draggedItemIcon.style.alignItems = "center";
    draggedItemIcon.style.justifyContent = "center";
    draggedItemIcon.innerText = "D"; // "D" for dragged item (replace with custom icon)

    const draggedItemName = document.createElement("span");
    draggedItemName.innerText = removeSlashAndExtension(file.fileName); // The dragged item's name
    draggedItemName.style.fontSize = "14px";
    draggedItemName.style.color = "#333";

    draggedItemContainer.appendChild(draggedItemIcon);
    draggedItemContainer.appendChild(draggedItemName);
    dragPreview.appendChild(draggedItemContainer);

    // Attach the custom drag image
    document.body.appendChild(dragPreview);
    e.dataTransfer.setDragImage(dragPreview, 0, 0);

    // Apply a 'dragging' effect to all items in the preview
    const previewItems = dragPreview.querySelectorAll("div"); // All items in the preview
    previewItems.forEach((item) => {
      item.style.opacity = "1"; // Ensure they are all visible during dragging
    });

    // Add the 'dragging' class to the target element
    e.target.classList.add("dragging");
  };

  // Function called when dragging over a folder
  const handleDragOver = (e) => {
    e.preventDefault(); // Necessary to allow a drop
    e.dataTransfer.dropEffect = "move";
  };

  const handleDragEnd = (e) => {
    e.target.classList.remove("dragging");
  };

  // Function called when a draggable item enters a droppable area
  const handleDragEnter = (e) => {
    e.preventDefault();
  };

  // Function called when the drop action occurs
  const handleDrop = (e, targetFolder) => {
    e.preventDefault();

    if (draggedItem && targetFolder.isFolder) {
      // Show move pop-up and then call move API
      // console.log(
      //   "Dragged item is",
      //   draggedItem,
      //   "Target folder is",
      //   targetFolder.isFolder
      // );
      if (targetFolder.isFolder === true) {
        setDragPop(true);
        setDragFile(draggedItem);
        setTargetFolder(targetFolder.fileName);
      }
    }

    // Reset the dragged item
    setDraggedItem(null);
  };

  const moveDraggedFile = async (filename) => {
    if (filename.isFolder === true) {
      // console.log("Shrey", [filename.fileName], [targetFolder]);
      try {
        const uploadId = Date.now() + Math.random(); // Ensures a unique uploadId for each file
        addUpload(uploadId, "Moving " + filename.fileName);

        const params = filename.isShared ? { shared: filenameRedux } : {}; // Add shared param if needed

        const res = await axios.post(
          `${apiUrl}move-folder`,
          {
            sourceFolders: [filename.fileName],
            destinationFolder: targetFolder,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            params, // Pass params to include shared if needed
            onUploadProgress: (progressEvent) => {
              const progress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              updateUploadProgress(uploadId, progress);
            },
          }
        );

        removeUpload(uploadId);
        setDragPop(false);
        reloadAfterTast();
        // console.log("Response is", res.data);
        showToast("success", "Folder Moved Successfully!");
      } catch (error) {
        showToast("error", "Failed to move folder!");
        console.error("Error moving folder:", error);
      }
    } else {
      const uploadId = Date.now() + Math.random(); // Ensures a unique uploadId for each file
      const movingFile = filename.fileName;
      addUpload(uploadId, "Moving " + movingFile);
      // console.log("Path to pass", path.replace(/\/+$/, "")); // Fix trailing slashes

      try {
        const params = filename.isShared ? { shared: filenameRedux } : {}; // Add shared param if needed

        let adjustedSourceFolder = path.replace(/\/+$/, ""); // Default sourceFolder without trailing slashes

        if (filename.isShared) {
          if (adjustedSourceFolder === filenameRedux) {
            adjustedSourceFolder = ""; // If source is only filenameRedux, send empty
          } else if (adjustedSourceFolder.startsWith(filenameRedux + "/")) {
            adjustedSourceFolder = adjustedSourceFolder.replace(
              filenameRedux + "/",
              ""
            ); // Remove filenameRedux/
          }
        }

        // Ensure all filenames are extracted correctly
        const fileKey = movingFile.includes("/")
          ? movingFile.substring(movingFile.lastIndexOf("/") + 1)
          : movingFile;

        const res = await axios.post(
          `${apiUrl}move-file`,
          {
            sourceFolder: adjustedSourceFolder, // Send modified sourceFolder
            destinationFolder: targetFolder.replace(/\/+$/, ""), // Remove trailing slashes
            keys: [fileKey], // Pass correct filename
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            params, // Pass params to include shared if needed
            onUploadProgress: (progressEvent) => {
              const progress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              updateUploadProgress(uploadId, progress);
            },
          }
        );

        setDragPop(false);
        removeUpload(uploadId);
        reloadAfterTast();
        // console.log(`"${movingFile}" moved successfully:`, res.data);
        showToast("success", `"${movingFile}" Moved Successfully!`);
      } catch (error) {
        // console.error(`Error moving file "${movingFile}":`, error);
        showToast(
          "error",
          `Failed to move file "${movingFile}". Please try again.`
        );
      }
    }
  };

  //Move multiple files
  const moveMultipleDrag = async (arr, folname) => {
    try {
      const uploadId = Date.now() + Math.random();
      addUpload(uploadId, "Moving Files..");
      // console.log("File to move is", arr);
      // console.log("Path to pass", path.replace(/\/$/, ""));

      for (const key of arr) {
        // console.log("key in array is ", key);
        const res = await axios.post(
          `${apiUrl}move-file`,
          {
            sourceFolder: path.replace(/\/$/, ""),
            destinationFolder: folname,
            keys: [key.substring(path.lastIndexOf("/") + 1)],
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            onUploadProgress: (progressEvent) => {
              // Simulating progress for folder move
              const progress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              updateUploadProgress(uploadId, progress);
            },
          }
        );

        setKeys([]);
        // console.log(res);
        setDragPop(false);
        removeUpload(uploadId);
        reloadAfterTast();

        showToast("success", "Files Moved Successfully!");
      }
    } catch (error) {
      // console.error(error);
    }
  };

  //Move multiple folders
  const moveMultipleDrag2 = async (arr, folname) => {
    try {
      if (arr && arr.length > 0) {
        const movingFolders = arr.join(", ");
        const uploadId = Date.now();
        addUpload(uploadId, "Moving " + movingFolders);

        const folderMoveRes = await axios.post(
          `${apiUrl}move-folder`,
          {
            sourceFolders: arr,
            destinationFolder: folname,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            onUploadProgress: (progressEvent) => {
              const progress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              updateUploadProgress(uploadId, progress);
            },
          }
        );
        setKeys2([]);
        setDragPop(false);
        removeUpload(uploadId);
        reloadAfterTast();
        // console.log("Folders moved successfully:", folderMoveRes.data);
        showToast("success", "Folders Moved Successfully!");
      }
    } catch (error) {
      console.error(error);
    }
  };
  const [showDropdown, setShowDropdown] = useState(false);

  // Function to show the dropdown when the "Move" button is clicked
  const handleMoveClick = () => {
    setShowDropdown(!showDropdown);
  };

  const [folders, setFolders] = useState([]);

  useEffect(() => {
    if (showImage) {
      const fetchInitialFolders = async () => {
        try {
          // Define API parameters
          let params = {};
          if (isSharedValue) {
            params.shared = filenameRedux; // Add shared param if isShared is true
          }

          const res = await axios.get(`${apiUrl}get-recent-folders`, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            params: params, // Pass params dynamically
          });

          // console.log("Recent folders are", res.data.result);
          setFolders(res.data.result);
          // console.log("folders are ", folders);
        } catch (error) {
          // console.error("There is an error at", error);
        }
      };

      fetchInitialFolders();
    }
  }, [showImage]);

  const folderOptions = folders.map((folder) => ({
    value: getModifiedRecentFolderText(folder.folder),
    label: getModifiedRecentFolderText(folder.folder),
  }));

  const handleChange = (event) => {
    const selectedOption = folderOptions.find(
      (folder) => folder.value === event.target.value
    );
    setSelectedFolder(selectedOption.value);
    handleFolderSelect(selectedOption); // Pass the selected folder to the handler
  };

  const handleFolderSelect = async (selectedOption) => {
    // console.log(modalFile);
    // console.log(selectedOption);

    try {
      const res = await axios.post(
        `${apiUrl}move-file`,
        {
          sourceFolder: path.replace(/\/$/, ""),
          destinationFolder: selectedOption.value.replace(/</g, "/"),
          keys: [modalFile.substring(path.lastIndexOf("/") + 1)],
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setSelectedFolder(null);
      // console.log(res.data.message);

      async function executeFunctionsInOrder() {
        try {
          showToast("success", "File Moved successfully");

          await reloadAfterTast();

          handleNext();
        } catch (error) {
          console.error("Error executing functions:", error);
        }
      }

      executeFunctionsInOrder();
    } catch (error) {
      console.error("There's a error");
      showToast("error", `Failed to move file.`);
    }
  };

  return (
    <>
      <ChakraProvider></ChakraProvider>
      {codePopup && (
        <div className="code-popup-overlay">
          <div className="code-popup-container">
            <button
              className="code-popup-close-btn"
              onClick={() => setCodePopup(false)}
              aria-label="Close"
            >
              ×
            </button>

            <h2 className="code-popup-title">Code Preview</h2>

            <div
              className="code-scroll-container"
              style={{ maxHeight: "70vh", overflowY: "auto" }}
              onScroll={handleScroll}
            >
              {codeChunks.map((chunk, idx) => (
                <SyntaxHighlighter
                  key={idx}
                  language={codeLanguage}
                  style={oneLight}
                  wrapLines
                  wrapLongLines
                  className="code-popup-highlighter"
                >
                  {chunk}
                </SyntaxHighlighter>
              ))}

              {isLoading1 && (
                <div
                  style={{
                    textAlign: "center",
                    padding: "10px",
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <img src={loaderGif} alt="" />
                  <p>Loading Code File....</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {infoShower && (
        <div className="file_info_wrapper">
          <div className="file_info_modal">
            <span
              className="file_info_close"
              onClick={() => setInfoShower(false)}
            >
              &times;
            </span>

            <h2 className="file_info_title">Details</h2>

            <div className="file_info_content">
              <div className="file_info_header">
                <img
                  src={fileInfo.fileIcon} // Replace with your actual icon path
                  alt="PDF Icon"
                  className="file_icon"
                />
                <div>
                  <h4 className="file_name">{fileInfo.fileName}</h4>
                  <p className="file_desc">{fileInfo.fileType} Document</p>
                </div>
              </div>

              <hr className="file_info_divider" />

              <p>
                <strong>File Size :</strong> <span>{fileInfo.fileSize}</span>
              </p>
              <p>
                <strong>File Type :</strong> <span>{fileInfo.fileType}</span>
              </p>
              <p>
                <strong>File URL :</strong>{" "}
                <a
                  href={fileInfo.fileUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="file_url"
                >
                  {fileInfo.fileUrl}
                </a>
              </p>
              <p>
                <strong>Upload Date :</strong>{" "}
                <span>{fileInfo.uploadDateTime}</span>
              </p>
            </div>
          </div>
        </div>
      )}
      {isVisibility && (
        <div title="" className="visibility-popover">
          <div className="visibility-popover-content">
            <div className="visibility-modal-content">
              {/* Close Button */}
              <button
                className="visibility-popup-close"
                onClick={() => {
                  setIsVisibility(false);
                }}
              >
                &times;
              </button>

              <h3 className="visibility-title">File Visibility</h3>

              <p className="visibility-instruction">
                Select the visibility option:
              </p>

              {/* Radio Options */}
              <div className="visibility-radio-container">
                <div className="visibility-radio-item">
                  <input
                    type="radio"
                    name="FileUpload"
                    id="FilePublic"
                    value="public"
                    onChange={handleRadioChange}
                    checked={pubpri2 === "public"}
                    className="visibility-radio-input"
                  />
                  <label
                    htmlFor="FilePublic"
                    className="visibility-radio-label"
                  >
                    Public
                  </label>
                </div>

                <div className="visibility-radio-item">
                  <input
                    type="radio"
                    name="FileUpload"
                    id="FilePrivate"
                    value="private"
                    onChange={handleRadioChange}
                    checked={pubpri2 === "private"}
                    className="visibility-radio-input"
                  />
                  <label
                    htmlFor="FilePrivate"
                    className="visibility-radio-label"
                  >
                    Private
                  </label>
                </div>
              </div>

              {/* Action Button */}
              <div className="visibility-button-group">
                <button
                  className="visibility-cancel-button"
                  onClick={() => {
                    setIsVisibility(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="visibility-apply-button"
                  onClick={() => {
                    changeVisibility(visiKey);
                  }}
                >
                  Change Visibility
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {renamePop && (
        <div className="rename_popup_wrapper">
          <div className="rename_modal">
            <h2 className="rename_title">Rename</h2>
            <p className="rename_subtext">
              Please enter a new name for the file:
            </p>

            <input
              className="rename_input"
              type="text"
              placeholder="Enter New Name"
              value={inputValue}
              onChange={handleInputChange}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  const sanitizedNewName = inputValue.trim();
                  handleFileRename(newFileName, sanitizedNewName, wholeFile);
                }
              }}
            />

            <div className="rename_buttons">
              <button
                className="rename_btn cancel"
                onClick={handleClosePopover}
              >
                Cancel
              </button>

              <button
                className="rename_btn ok"
                disabled={isRenaming}
                onClick={() => {
                  const sanitizedNewName = inputValue.trim();
                  handleFileRename(newFileName, sanitizedNewName, wholeFile);
                }}
              >
                {isRenaming ? "Renaming..." : "OK"}
              </button>
            </div>

            {/* You can style or use this block when you show success */}
            <div className="thankyou_popover" style={{ display: "none" }}>
              <svg
                className="checkmark"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 52 52"
              >
                <circle
                  className="checkmark__circle"
                  cx="26"
                  cy="26"
                  r="25"
                  fill="none"
                />
                <path
                  className="checkmark__check"
                  fill="none"
                  d="M14.1 27.2l7.1 7.2 16.7-16.8"
                />
              </svg>
              <h1>Thank You!</h1>
              <p>For Rename File</p>
            </div>
          </div>
        </div>
      )}

      {deletePop && (
        <div className="rename_popup_wrapper">
          <div className="rename_modal">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "15px",
              }}
            >
              <img src={DeletePopup} alt="" />
            </div>
            <h2 className="rename_title2">Are you sure you want to delete?</h2>
            <p className="rename_subtext">This action cannot be reversed</p>
            <div className="rename_buttons">
              <button
                className="rename_btn cancel"
                onClick={handleCloseDeletePopover}
              >
                No
              </button>
              <button
                className="rename_btn ok"
                onClick={() => handleFileDelete(activeDeleteRow)}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}

      {dragPop && (
        <div className="drag_popup_wrapper">
          <div className="drag_modal">
            <h2 className="rename_title2">Are you sure you want to Move?</h2>

            <div className="drag_buttons">
              <button
                className="drag_btn cancel"
                onClick={() => setDragPop(false)}
              >
                No
              </button>
              <button
                className="drag_btn ok"
                onClick={() => {
                  moveDraggedFile(dragFile);
                  if (keys.length > 0) {
                    moveMultipleDrag(keys, targetFolder);
                  }
                  if (keys2.length > 0) {
                    moveMultipleDrag2(keys2, targetFolder);
                  }
                }}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
      {downloadPopup && (
        <div className="rename_popup_wrapper">
          <div className="rename_modal">
            <h2 className="rename_title2" style={{ marginBottom: 16 }}>
              {loading
                ? `Downloading... ${progress}%`
                : "Are you sure you want to download?"}
            </h2>

            {/* Progress Bar */}
            <div
              className="download_progress_wrapper"
              style={{ display: loading ? "block" : "none" }}
            >
              <div
                className="download_progress_bar"
                style={{ width: `${progress}%` }}
              ></div>
            </div>

            <div className="rename_buttons" style={{ marginTop: 24 }}>
              <button
                className="rename_btn cancel"
                onClick={handleCancelDownload}
              >
                {loading ? "Cancel" : "No"}
              </button>

              {!loading && (
                <button
                  className="rename_btn ok"
                  onClick={handleConfirmDownload}
                >
                  Yes
                </button>
              )}
            </div>
          </div>
        </div>
      )}
      {sharePopup && (
        <div className="file-share-popup-wrapper">
          <div className="file-share-modal">
            <div className="file-share-header">
              <h2 className="file-share-title">Share File URL</h2>
              <button
                className="file-share-close-icon"
                onClick={closeSharePopup}
              >
                ×
              </button>
            </div>

            <div className="file-share-access-controls-section">
              <h3 className="file-share-section-title">ACCESS CONTROLS</h3>
              <p className="file-share-section-description">
                Choose how long others can access this file.
              </p>

              <div className="file-share-access-options">
                <label className="file-share-radio-label">
                  <input
                    type="radio"
                    name="access-type"
                    value="permanent"
                    checked={shareMode === "permanent"}
                    onChange={() => setShareMode("permanent")}
                    className="file-share-radio-input"
                  />
                  <span className="file-share-radio-custom"></span>
                  Permanent
                </label>

                <label className="file-share-radio-label">
                  <input
                    type="radio"
                    name="access-type"
                    value="limited"
                    checked={shareMode === "limited"}
                    onChange={() => setShareMode("limited")}
                    className="file-share-radio-input"
                  />
                  <span className="file-share-radio-custom"></span>
                  Limited Time
                </label>
              </div>
            </div>

            {/* Conditional Time Input */}
            {shareMode === "limited" && (
              <div className="file-share-time-selection-row">
                <div className="file-share-dropdown-container">
                  <label className="file-share-time-label">Expiry Time</label>
                  <select
                    className={`file-share-time-dropdown ${
                      !useManualEntry ? "file-share-active" : ""
                    }`}
                    value={selectedTimeOption}
                    onChange={(e) => {
                      setSelectedTimeOption(e.target.value);
                      focusDropdown();
                    }}
                    onClick={focusDropdown}
                  >
                    {timeOptions.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="file-share-manual-time-container">
                  <label className="file-share-time-label">
                    Manual Time Entry
                  </label>
                  <div className="file-share-manual-time-input-group file-share-active">
                    <div
                      className="file-share-time-unit"
                      onClick={toggleTimeUnit}
                      style={{ cursor: "pointer" }}
                    >
                      {manualTimeUnit}{" "}
                      <span className="file-share-bidirectional">⇌</span>
                    </div>

                    <div className="file-share-separator">|</div>
                    <input
                      type="text"
                      className="file-share-manual-time-input"
                      placeholder="Time/Hour/Day"
                      value={manualTimeValue}
                      onChange={(e) => {
                        setManualTimeValue(e.target.value);
                        focusManualInput();
                      }}
                      onClick={focusManualInput}
                    />
                  </div>
                </div>
              </div>
            )}

            <div className="file-share-action-buttons">
              <button
                className="file-share-close-button"
                onClick={closeSharePopup}
              >
                Close
              </button>
              <button
                className="file-share-get-link-button"
                onClick={handleGenerateAndCopy}
              >
                Get Link
              </button>
            </div>
          </div>
        </div>
      )}

      <SideNav />

      <div className="container-fluid page-body-wrapper">
        {/* partial:partials/_navbar.html */}
        <nav className="navbar p-0 fixed-top d-flex flex-row">
          <div className="navbar-brand-wrapper d-flex d-lg-none align-items-center justify-content-center">
            <a className="navbar-brand brand-logo-mini" href="#">
              <img src={Logo} alt="logo" />
            </a>
          </div>
          <div className="navbar-menu-wrapper flex-grow d-flex align-items-stretch">
            <ToggleNav />
            <div className="navbar-nav page_title">
              <h1>Recent Uploads</h1>

              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <Link to="/Files">Home</Link>
                  </li>
                  <li class="breadcrumb-item">
                    {parts.map((part, index) => (
                      <span key={index}>
                        <a
                          href="#"
                          onClick={(event) =>
                            handleBreadClick(event, part, index, parts.length)
                          }
                        >
                          {part}
                        </a>
                        {index < parts.length - 1 && <span> &gt; </span>}
                      </span>
                    ))}
                  </li>
                </ol>
              </nav>

              {/* <div className="breadcrumb">
            {<Link to="/Files">← Back</Link>} &gt;&nbsp;
            {parts.map((part, index) => (
            <span key={index}>
            <a href="#" onClick={(event) => handleBreadClick(event, part, index, parts.length)}>
             
             {part}
            </a>
            {index < parts.length - 1 && <span> &gt; </span>}
            </span>
            ))}

            </div> */}
            </div>
          </div>
        </nav>
        {/* partial */}
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="table_box">
              <div className="filerbar_row">
                <div className="show_entries_row">
                  <div className="custom-search-bar">
                    <img
                      src={SearchIcon}
                      alt="search"
                      className="custom-search-icon"
                    />
                    <input
                      value={query}
                      onChange={(e) => setQuery(e.target.value)}
                      type="text"
                      className="custom-search-input"
                      placeholder="Search"
                    />
                    {query && (
                      <button
                        className="clear-search-btn"
                        onClick={clearSearch}
                      >
                        ✕
                      </button>
                    )}
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 15 }}>
                  <div
                    className={`switcher-container ${
                      view === "list" ? "list-active" : "grid-active"
                    }`}
                  >
                    <img
                      src={view === "list" ? IconListW : IconList}
                      alt="List View"
                      className={`list-view-img ${
                        view === "list" ? "active" : ""
                      }`}
                      onClick={() => toggleView("list")}
                    />
                    {/* <div className="switcher-divider"></div> */}
                    <img
                      src={view === "grid" ? IconHomeW : IconHome}
                      alt="Grid View"
                      className={`grid-view-img ${
                        view === "grid" ? "active" : ""
                      }`}
                      onClick={() => toggleView("grid")}
                    />
                  </div>
                  <div className="filterbar">
                    <div
                      className="dropdown dropdown-processed"
                      style={{
                        // borderLeft: "1px solid #d7d6ef",
                        width: "-webkit-fill-available",
                      }}
                    >
                      {/* <a className="dropdown-link" href="#"><i className='icon-sorting'></i> <span id="sortingtxt">Sorting</span></a> */}
                      <Dropdown
                        onSelect={handleFilterSelect}
                        title={
                          <span className="sort-filter-span">
                            <img src={SortHome} alt="" /> {selectedFilter}
                          </span>
                        }
                        className="filter_dropdown"
                      >
                        <Dropdown.Item eventKey="name-filter1">
                          By Name(A-Z)
                        </Dropdown.Item>
                        <Dropdown.Item eventKey="name-filter2">
                          By Name(Z-A)
                        </Dropdown.Item>
                        <Dropdown.Item eventKey="size-filter1">
                          By Size(Ascending)
                        </Dropdown.Item>
                        <Dropdown.Item eventKey="size-filter2">
                          By Size(Descending)
                        </Dropdown.Item>
                        <Dropdown.Item eventKey="date-filter1">
                          By Date(Oldest)
                        </Dropdown.Item>
                        <Dropdown.Item eventKey="date-filter2">
                          By Date(Newest)
                        </Dropdown.Item>
                      </Dropdown>
                    </div>
                    <div
                      className="dropdown dropdown-processed"
                      style={{ width: "-webkit-fill-available" }}
                    >
                      <Dropdown
                        onSelect={handleFTypeSelect}
                        title={
                          <span className="sort-filter-span">
                            <img src={FilterHome} alt="" /> File Type
                          </span>
                        }
                        className="filter_dropdown"
                        onClick={() => setShowFTPopup(true)} // Show the modal when dropdown is clicked
                      >
                        {/* You can remove the Dropdown.Item since it’s not needed anymore */}
                      </Dropdown>

                      <BootstrapModal
                        show={showFTPopup}
                        onHide={closePopup}
                        className="file-type-filter-modal"
                      >
                        <BootstrapModal.Header>
                          <BootstrapModal.Title className="file-type-filter-title">
                            File Type Filter
                          </BootstrapModal.Title>
                        </BootstrapModal.Header>
                        <BootstrapModal.Body className="file-type-filter-body">
                          <p className="file-type-filter-instruction">
                            Select the file types you want to filter by:
                          </p>

                          <div className="file-type-checkbox-container">
                            {fileTypes.map((fileType) => (
                              <div
                                key={fileType}
                                className="file-type-checkbox-item"
                              >
                                <input
                                  type="checkbox"
                                  id={fileType}
                                  value={fileType}
                                  checked={selectedFileTypes.includes(fileType)}
                                  onChange={() =>
                                    handleFTCheckboxChange(fileType)
                                  }
                                  className="file-type-checkbox-input"
                                />
                                <label
                                  htmlFor={fileType}
                                  className="file-type-checkbox-label"
                                >
                                  {fileType.toUpperCase()}
                                </label>
                              </div>
                            ))}
                          </div>
                        </BootstrapModal.Body>
                        <BootstrapModal.Footer className="file-type-filter-footer">
                          <div className="file-type-button-group">
                            <button
                              onClick={closePopup}
                              className="file-type-cancel-button"
                            >
                              Cancel
                            </button>
                            <button
                              onClick={applyFilter}
                              className="file-type-apply-button"
                            >
                              Filter
                            </button>
                          </div>
                        </BootstrapModal.Footer>
                      </BootstrapModal>
                    </div>
                  </div>
                  <button
                    onClick={handleOpenCreateFolder}
                    className="download-btn2"
                  >
                    <img src={CreateFolder} />
                    Create Folder
                  </button>
                  <button
                    onClick={() => setIsDownloadModalOpen(true)}
                    className="download-btn"
                  >
                    <img src={DownloafFromUrl} alt="" />
                    <span>Download from URL</span>
                  </button>
                  <button
                    onClick={handleOpenFileUploadModal}
                    className="btn__upload__file_modal"
                  >
                    <img src={IconUpload} />
                    Upload Files
                  </button>
                </div>
              </div>

              {(keys.length > 0 || keys2.length > 0) && (
                <div className="selected_table_row">
                  <div className="selected_table_text">
                    <button
                      onClick={() => {
                        setKeys([]);
                        setKeys2([]);
                      }}
                      className="selected_close_table"
                    >
                      <i className="icon-cross"></i>
                    </button>
                    <span>{keys.length + keys2.length} Selected</span>
                    <button onClick={handleSelectAllToggle} class="button-18">
                      {isSelectAll ? "Deselect All" : "Select All"}
                    </button>
                  </div>

                  <ul className="selected_table_icons">
                    <li>
                      <button
                        onClick={() => {
                          if (keys2.length > 0) {
                            showToast("error", "Copy folder is not available!");
                          } else {
                            setIsCWhisperClicked(true);
                          }
                        }}
                        class="icon-copy"
                      ></button>
                    </li>
                    <li>
                      <button
                        onClick={() => {
                          setIsWhisperClicked(true);
                        }}
                        class="icon-move"
                      ></button>
                    </li>
                    <li>
                      <button
                        onClick={() => {
                          handleMulDelete();
                        }}
                        class="icon-delete2"
                      ></button>
                    </li>
                  </ul>
                </div>
              )}

              {isLoading ? (
                <Placeholder.Grid
                  rows={10}
                  columns={5}
                  active
                  style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 12 }}
                />
              ) : (
                <div id="dataView">
                  {view === "list" ? (
                    <div className="table-responsive">
                      <table id="filestable" className="table table-striped">
                        <thead>
                          <tr>
                            <th style={{ width: "40px", textAlign: "center" }}>
                              <input
                                id="check-Atharva"
                                type="checkbox"
                                onChange={handleSelectAllToggle}
                                checked={isSelectAll}
                              />
                            </th>

                            <th
                              style={{
                                width: "60%",
                                fontWeight: 600,
                                color: "#181818",
                              }}
                            >
                              <span
                                className="column-name-new"
                                style={{ alignItems: "center" }}
                              >
                                File Name
                                <img
                                  src={SortIcon}
                                  alt=""
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    handleFilterSelect(
                                      selectedFilter === "By Name(A-Z)"
                                        ? "name-filter2"
                                        : "name-filter1"
                                    )
                                  }
                                />
                              </span>
                            </th>

                            <th
                              style={{
                                width: "15%",
                                fontWeight: 600,
                                color: "#181818",
                                justifyContent: "center",
                              }}
                            >
                              <span
                                className="column-name-new"
                                style={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                File Size
                                <img
                                  src={SortIcon}
                                  alt=""
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    handleFilterSelect(
                                      selectedFilter === "By Size(Asc)"
                                        ? "size-filter2"
                                        : "size-filter1"
                                    )
                                  }
                                />
                              </span>
                            </th>

                            <th
                              style={{
                                width: "15%",
                                fontWeight: 600,
                                color: "#181818",
                                justifyContent: "center",
                              }}
                            >
                              <span
                                className="column-name-new"
                                style={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                Modified On
                                <img
                                  src={SortIcon}
                                  alt=""
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    handleFilterSelect(
                                      selectedFilter === "By Date(Oldest)"
                                        ? "date-filter2"
                                        : "date-filter1"
                                    )
                                  }
                                />
                              </span>
                            </th>

                            <th
                              style={{
                                width: "15%",
                                fontWeight: 600,
                                color: "#181818",
                                textAlign: "center",
                              }}
                            >
                              Action
                            </th>
                          </tr>
                        </thead>
                        {paginatedData.length === 0 ? (
                          <tr>
                            <td colSpan="6" className="text-center">
                              No files or folders found.
                            </td>
                          </tr>
                        ) : (
                          paginatedData.map((file, index) => {
                            return (
                              <tbody>
                                <tr
                                  className={`hover_cell ${
                                    activeRow === 1 ? "active-row" : ""
                                  }`}
                                  draggable={true}
                                  onDragStart={(e) => handleDragStart(e, file)}
                                  onDragOver={
                                    file.isFolder ? handleDragOver : null
                                  }
                                  onDragEnter={
                                    file.isFolder ? handleDragEnter : null
                                  }
                                  onDragEnd={handleDragEnd}
                                  onDrop={
                                    file.isFolder
                                      ? (e) => handleDrop(e, file)
                                      : null
                                  }
                                >
                                  <td>
                                    <input
                                      id="check-Atharva"
                                      type="checkbox"
                                      onChange={() =>
                                        handleCheckboxChange(file)
                                      }
                                      checked={
                                        file.isFolder
                                          ? keys2.includes(file.fileName)
                                          : keys.includes(file.fileName)
                                      }
                                    ></input>
                                  </td>

                                  {/* <td align="center">{index + 1}</td> */}
                                  {/* <td>
                              <span
                                className="filename_link"
                                style={{ cursor: "pointer" }}
                              >
                                <img
                                  src={file.icon}
                                  height={32}
                                  alt="File Icon"
                                />
                              </span>
                            </td> */}
                                  <td
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "10px",
                                    }}
                                  >
                                    <span
                                      className="filename_link"
                                      style={{ cursor: "pointer" }}
                                    >
                                      <img src={file.icon} height={32} />
                                    </span>

                                    <span
                                      className="filename_link"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setErrorMessage2("");

                                        const isFolder =
                                          file.fileType === "Folder" ||
                                          file.isFolder === true;

                                        if (isFolder) {
                                          chkFileorFolder(file, file.fileSize);
                                          return;
                                        }

                                        const codeExtensions = [
                                          "js",
                                          "jsx",
                                          "ts",
                                          "tsx",
                                          "html",
                                          "css",
                                          "json",
                                          "xml",
                                          "py",
                                          "java",
                                          "c",
                                          "cpp",
                                          "rb",
                                          "php",
                                          "sh",
                                          "go",
                                          "cs",
                                        ];

                                        const fileTypeLower =
                                          file.fileType?.toLowerCase();

                                        if (
                                          codeExtensions.includes(fileTypeLower)
                                        ) {
                                          // show code modal for supported source code files
                                          previewCodeFile(file); // Assuming this calls the API and sets codeContent
                                          return;
                                        }

                                        if (
                                          [
                                            "mkv",
                                            "mp4",
                                            "mov",
                                            "mpeg",
                                            "webm",
                                          ].includes(fileTypeLower)
                                        ) {
                                          setModalFile(file.fileName);
                                          handleImageShow();
                                          setVideoSrc(file.fileName);
                                          const index = filedata.findIndex(
                                            (f) => f.fileName === file.fileName
                                          );
                                          if (index !== -1)
                                            setCurrentImageIndex(index);
                                          return;
                                        }

                                        if (
                                          [
                                            "jpeg",
                                            "jpg",
                                            "png",
                                            "gif",
                                            "hevc",
                                            "heif",
                                            "svg",
                                            "webp",
                                          ].includes(fileTypeLower)
                                        ) {
                                          setModalFile(file.fileName);
                                          handleImageShow();
                                          getImageInfo(file.fileName);
                                          const index = filedata.findIndex(
                                            (f) => f.fileName === file.fileName
                                          );
                                          if (index !== -1)
                                            setCurrentImageIndex(index);
                                          return;
                                        }

                                        if (
                                          ["mp3", "wav", "ogg", "aac"].includes(
                                            fileTypeLower
                                          )
                                        ) {
                                          setModalFile(file.fileName);
                                          handleImageShow();
                                          getAudioInfo(file.fileName);
                                          const index = filedata.findIndex(
                                            (f) => f.fileName === file.fileName
                                          );
                                          if (index !== -1)
                                            setCurrentImageIndex(index);
                                          return;
                                        }

                                        if (
                                          ["pdf", "txt"].includes(fileTypeLower)
                                        ) {
                                          setModalFile(file.fileName);
                                          handleImageShow();
                                          getPdfInfo(file.fileName);
                                          const index = filedata.findIndex(
                                            (f) => f.fileName === file.fileName
                                          );
                                          if (index !== -1)
                                            setCurrentImageIndex(index);
                                          return;
                                        }

                                        handleImageShow();
                                        setErrorMessage2(
                                          "File format not supported!"
                                        );
                                        const index = filedata.findIndex(
                                          (f) => f.fileName === file.fileName
                                        );
                                        if (index !== -1)
                                          setCurrentImageIndex(index);
                                      }}
                                    >
                                      {customTruncateFileName(
                                        removeSlash(file.fileName),
                                        55
                                      )}
                                    </span>
                                  </td>

                                  <td
                                    class="fileSizeTL"
                                    data-sort={1673004}
                                    style={{
                                      textAlign: "center",
                                      fontWeight: "500",
                                    }}
                                  >
                                    <span style={{ fontWeight: "500" }}>
                                      {file.fileSize}
                                    </span>
                                  </td>
                                  <td
                                    class="fileSizeTD"
                                    data-sort="2023-12-16 07:32:38"
                                    style={{ textAlign: "center" }}
                                  >
                                    <p>
                                      {file.uploadDateTime.substring(
                                        0,
                                        file.uploadDateTime.indexOf(",")
                                      )}
                                    </p>
                                    <span>
                                      {file.uploadDateTime
                                        .substring(
                                          file.uploadDateTime.indexOf(",") + 1
                                        )
                                        .trim()}
                                    </span>
                                  </td>

                                  <td style={{ textAlign: "center" }}>
                                    <div className="dropdown">
                                      <button
                                        className="dropdown-toggle"
                                        type="button"
                                        id="dropdownMenuButton"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                      >
                                        <svg
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                          class="feather feather-more-vertical"
                                        >
                                          <circle
                                            cx="12"
                                            cy="12"
                                            r="1"
                                          ></circle>
                                          <circle cx="12" cy="5" r="1"></circle>
                                          <circle
                                            cx="12"
                                            cy="19"
                                            r="1"
                                          ></circle>
                                        </svg>
                                      </button>
                                      <div
                                        className="dropdown-menu custom-dropdown-menu"
                                        style={{
                                          transform:
                                            "translate3d(-321px, -25px, 0px)",
                                        }}
                                        // aria-labelledby="dropdownMenuButton"
                                      >
                                        {/* {file.isFolder === false && (
                                    <a
                                      className="dropdown-item"
                                      href="#"
                                      onClick={() => {
                                        setIsVisibility(true);
                                        setVisiKey(file.fileName);
                                        setPubPri(file.ACL);
                                      }}
                                    >
                                      <i className="icon-view" />
                                      Change Visibility
                                    </a>
                                  )} */}
                                        <a className="file-container">
                                          <div className="file-icon">
                                            <img
                                              src={file.icon}
                                              alt="file icon"
                                              height={32}
                                            />
                                          </div>
                                          <div className="file-details">
                                            <div className="file-name">
                                              {customTruncateFileName(
                                                removeSlash(file.fileName),
                                                55
                                              )}
                                            </div>
                                            <div className="upload-date">
                                              <p>
                                                Uploaded on{" "}
                                                {file.uploadDateTime.substring(
                                                  0,
                                                  file.uploadDateTime.indexOf(
                                                    ","
                                                  )
                                                )}
                                              </p>
                                              <span>• {file.fileSize}</span>
                                            </div>
                                          </div>
                                        </a>
                                        {file.isFolder === false && (
                                          <a
                                            className="dropdown-item dropdown-item-custom"
                                            href="#"
                                            onClick={() => shareFile(file)}
                                          >
                                            <img
                                              src={shareIcon}
                                              alt="Share"
                                              className="dropdown-icon-list"
                                            />
                                            Share
                                          </a>
                                        )}
                                        {file.isFolder === false && (
                                          <a
                                            className="dropdown-item dropdown-item-custom"
                                            href="#"
                                            onClick={() => {
                                              setIsVisibility(true);
                                              setVisiKey(file.fileName);
                                              setPubPri(file.ACL);
                                            }}
                                          >
                                            <img
                                              src={eyeIcon}
                                              alt="Share"
                                              className="dropdown-icon-list"
                                            />
                                            Change Visibility
                                          </a>
                                        )}

                                        {file.fileName.includes(".zip") ? (
                                          <a
                                            className={`dropdown-item dropdown-item-custom ${
                                              file?.isShared
                                                ? "disabled blur-effect"
                                                : ""
                                            }`}
                                            href="#"
                                            onClick={() =>
                                              !file?.isShared && UnzipFile(file)
                                            }
                                            style={
                                              file?.isShared
                                                ? {
                                                    pointerEvents: "none",
                                                    opacity: 0.5,
                                                  }
                                                : {}
                                            }
                                          >
                                            <img
                                              src={UnZipIcon}
                                              alt="Unzip"
                                              className="dropdown-icon-list"
                                            />
                                            Unzip
                                          </a>
                                        ) : (
                                          <a
                                            className={`dropdown-item dropdown-item-custom ${
                                              file?.isShared
                                                ? "disabled blur-effect"
                                                : ""
                                            }`}
                                            href="#"
                                            onClick={() =>
                                              !file?.isShared && ZipFile(file)
                                            }
                                            style={
                                              file?.isShared
                                                ? {
                                                    pointerEvents: "none",
                                                    opacity: 0.5,
                                                  }
                                                : {}
                                            }
                                          >
                                            <img
                                              src={ZipIcon}
                                              alt="Zip"
                                              className="dropdown-icon-list"
                                            />
                                            Zip
                                          </a>
                                        )}
                                        {/* {file.isFolder === false && ( */}
                                        <a
                                          className={`dropdown-item dropdown-item-custom ${
                                            file?.isShared
                                              ? "disabled blur-effect"
                                              : ""
                                          }`}
                                          href="#"
                                          onClick={() =>
                                            !file?.isShared &&
                                            downloadFile(file)
                                          }
                                          style={
                                            file?.isShared
                                              ? {
                                                  pointerEvents: "none",
                                                  opacity: 0.5,
                                                }
                                              : {}
                                          }
                                        >
                                          <img
                                            src={downloadIcon}
                                            alt="Download"
                                            className="dropdown-icon-list"
                                          />
                                          Download
                                        </a>
                                        {/* )} */}
                                        <a
                                          className="dropdown-item dropdown-item-custom"
                                          href="#"
                                          onClick={() =>
                                            handleOpenPopover(file)
                                          }
                                        >
                                          <img
                                            src={renameIcon}
                                            alt="Rename"
                                            className="dropdown-icon-list"
                                          />
                                          Rename
                                        </a>
                                        {/* {file.isFolder === false && (
                                        <a
                                          className="dropdown-item dropdown-item-custom"
                                          href="#"
                                          onClick={() =>
                                            handleAddToFavorites(file)
                                          }
                                        >
                                          <img
                                            src={favouritesIcon}
                                            alt="Add to Favorites"
                                            className="dropdown-icon-list"
                                          />
                                          Add to Favorites
                                        </a>
                                      )} */}
                                        <a
                                          className="dropdown-item dropdown-item-custom"
                                          href="#"
                                          onClick={() => {
                                            if (file.isFolder) {
                                              handleMFClick(file.fileName);
                                            } else {
                                              handleMClick(file.fileName);
                                            }
                                          }}
                                        >
                                          <img
                                            src={moveIcon2}
                                            alt="Move"
                                            className="dropdown-icon-list"
                                          />
                                          Move to
                                        </a>
                                        {file.isFolder === false && (
                                          <a
                                            className="dropdown-item dropdown-item-custom"
                                            href="#"
                                            onClick={() =>
                                              handleCClick(file.fileName)
                                            }
                                          >
                                            <img
                                              src={copyIcon}
                                              alt="Copy"
                                              className="dropdown-icon-list"
                                            />
                                            Copy to
                                          </a>
                                        )}
                                        {/* {file.isFolder === false && (
                                        <a
                                          className="dropdown-item dropdown-item-custom"
                                          href="#"
                                          onClick={() =>
                                            handleGenerateLink(file)
                                          }
                                        >
                                          <img
                                            src={linkIcon}
                                            alt="Generate Short Link"
                                            className="dropdown-icon-list"
                                          />
                                          Generate Short Link
                                        </a>
                                      )} */}
                                        {file.isFolder === false && (
                                          <a
                                            className="dropdown-item dropdown-item-custom"
                                            href="#"
                                            onClick={() => {
                                              setInfoShower(true);
                                              getFileInfo(file.fileName);
                                            }}
                                          >
                                            <img
                                              src={InfoIcon}
                                              alt="Copy"
                                              className="dropdown-icon-list"
                                            />
                                            Information
                                          </a>
                                        )}

                                        <a
                                          className="dropdown-item dropdown-item-custom"
                                          href="#"
                                          onClick={() =>
                                            handleOpenDeletePopover(file)
                                          }
                                        >
                                          <img
                                            src={deleteIcon2}
                                            alt="Delete"
                                            className="dropdown-icon-list"
                                          />
                                          Delete
                                        </a>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            );
                          })
                        )}
                      </table>
                    </div>
                  ) : (
                    <>
                      <th style={{ width: "40px", textAlign: "center" }}>
                        <input
                          id="check-Atharva"
                          type="checkbox"
                          onChange={handleSelectAllToggle}
                          checked={isSelectAll}
                        />
                      </th>

                      <th
                        style={{
                          width: "60%",
                          fontWeight: 600,
                          color: "#181818",
                        }}
                      >
                        <span
                          className="column-name-new"
                          style={{ alignItems: "center" }}
                        >
                          File Name
                          <img
                            src={SortIcon}
                            alt=""
                            style={{ cursor: "pointer", marginLeft: 6 }}
                            onClick={() =>
                              handleFilterSelect(
                                selectedFilter === "By Name(A-Z)"
                                  ? "name-filter2"
                                  : "name-filter1"
                              )
                            }
                          />
                        </span>
                      </th>
                      <div className="grid-view2">
                        {paginatedData.length === 0 ? (
                          <div style={{ display: "flex" }}>
                            <span className="text-center">
                              No files or folders found.
                            </span>
                          </div>
                        ) : (
                          paginatedData.map((file, index) => (
                            <div
                              className={`grid-item2 ${
                                draggedItem?.fileName === file.fileName
                                  ? "dragging"
                                  : ""
                              }`}
                              key={index}
                              style={{ cursor: "pointer" }}
                              draggable={true}
                              onDragStart={(e) => handleDragStart(e, file)}
                              onDragOver={(e) => {
                                e.preventDefault(); // Necessary to allow dropping
                                if (file.isFolder)
                                  e.dataTransfer.dropEffect = "move";
                              }}
                              onDragEnter={(e) => {
                                if (file.isFolder) e.preventDefault();
                              }}
                              onDragEnd={handleDragEnd}
                              onDrop={(e) => {
                                if (file.isFolder) handleDrop(e, file);
                              }}
                              onClick={(event) => {
                                if (
                                  !event.target.closest(".dropdown-toggle") &&
                                  !event.target.closest(".checkbox-input") &&
                                  !event.target.closest(".custom-dropdown-menu")
                                ) {
                                  setErrorMessage2("");

                                  const codeExtensions = [
                                    "js",
                                    "jsx",
                                    "ts",
                                    "tsx",
                                    "html",
                                    "css",
                                    "json",
                                    "xml",
                                    "py",
                                    "java",
                                    "c",
                                    "cpp",
                                    "rb",
                                    "php",
                                    "sh",
                                    "go",
                                    "cs",
                                  ];
                                  const fileTypeLower =
                                    file.fileType?.toLowerCase();

                                  // CODE FILE DETECTION
                                  if (codeExtensions.includes(fileTypeLower)) {
                                    previewCodeFile(file); // <-- handles API call + setCodeContent + open modal
                                    return;
                                  }

                                  if (
                                    [
                                      "mkv",
                                      "mp4",
                                      "mov",
                                      "mpeg",
                                      "webm",
                                      "MOV",
                                    ].includes(fileTypeLower)
                                  ) {
                                    setModalFile(file.fileName);
                                    handleImageShow();
                                    const index = filedata.findIndex(
                                      (f) => f.fileName === file.fileName
                                    );
                                    if (index !== -1)
                                      setCurrentImageIndex(index);
                                    setVideoSrc(file.fileName);
                                  } else if (
                                    [
                                      "jpeg",
                                      "jpg",
                                      "png",
                                      "gif",
                                      "hevc",
                                      "heif",
                                      "svg",
                                      "webp",
                                      "JPEG",
                                      "JPG",
                                      "PNG",
                                      "GIF",
                                      "HEVC",
                                      "HEIF",
                                      "SVG",
                                      "WEBP",
                                    ].includes(file.fileType)
                                  ) {
                                    setModalFile(file.fileName);
                                    handleImageShow();
                                    const index = filedata.findIndex(
                                      (f) => f.fileName === file.fileName
                                    );
                                    if (index !== -1)
                                      setCurrentImageIndex(index);
                                    getImageInfo(file.fileName);
                                  } else if (
                                    [
                                      "mp3",
                                      "MP3",
                                      "wav",
                                      "WAV",
                                      "ogg",
                                      "OGG",
                                      "aac",
                                      "AAC",
                                    ].includes(file.fileType)
                                  ) {
                                    setModalFile(file.fileName);
                                    handleImageShow();
                                    const index = filedata.findIndex(
                                      (f) => f.fileName === file.fileName
                                    );
                                    if (index !== -1)
                                      setCurrentImageIndex(index);
                                    getAudioInfo(file.fileName);
                                  } else if (
                                    ["pdf", "PDF", "txt", "TXT"].includes(
                                      file.fileType
                                    )
                                  ) {
                                    setModalFile(file.fileName);
                                    handleImageShow();
                                    const index = filedata.findIndex(
                                      (f) => f.fileName === file.fileName
                                    );
                                    if (index !== -1)
                                      setCurrentImageIndex(index);
                                    getPdfInfo(file.fileName);
                                  } else {
                                    if (file.isFolder === true) {
                                      chkFileorFolder(file, file.fileSize);
                                    } else {
                                      handleImageShow();
                                      setErrorMessage2(
                                        "File format not supported!"
                                      );
                                      const index = filedata.findIndex(
                                        (f) => f.fileName === file.fileName
                                      );
                                      if (index !== -1)
                                        setCurrentImageIndex(index);
                                    }
                                  }
                                }
                              }}
                            >
                              <input
                                id="check-Atharva"
                                type="checkbox"
                                className="checkbox-input"
                                onClick={(event) => event.stopPropagation()} // Stops click from bubbling to parent
                                onChange={() => handleCheckboxChange(file)}
                                checked={
                                  file.isFolder
                                    ? keys2.includes(file.fileName)
                                    : keys.includes(file.fileName)
                                }
                              />
                              {/* Three Dots Menu */}

                              <div className="menu-icon2">
                                <div className="dropdown">
                                  <button
                                    className="dropdown-toggle"
                                    type="button"
                                    id="dropdownMenuButton"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                  >
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="feather feather-more-vertical"
                                    >
                                      <circle cx="12" cy="12" r="1"></circle>
                                      <circle cx="12" cy="5" r="1"></circle>
                                      <circle cx="12" cy="19" r="1"></circle>
                                    </svg>
                                  </button>
                                  <div
                                    className="dropdown-menu custom-dropdown-menu"
                                    style={{
                                      transform:
                                        "translate3d(-242px, -25px, 0px)",
                                    }}
                                    // aria-labelledby="dropdownMenuButton"
                                  >
                                    {/* {file.isFolder === false && (
                                    <a
                                      className="dropdown-item"
                                      href="#"
                                      onClick={() => {
                                        setIsVisibility(true);
                                        setVisiKey(file.fileName);
                                        setPubPri(file.ACL);
                                      }}
                                    >
                                      <i className="icon-view" />
                                      Change Visibility
                                    </a>
                                  )} */}
                                    <a className="file-container">
                                      <div className="file-icon">
                                        <img
                                          src={file.icon}
                                          alt="file icon"
                                          height={32}
                                        />
                                      </div>
                                      <div className="file-details">
                                        <div className="file-name">
                                          {customTruncateFileName(
                                            removeSlash(file.fileName),
                                            55
                                          )}
                                        </div>
                                        <div className="upload-date">
                                          <p>
                                            Uploaded on{" "}
                                            {file.uploadDateTime.substring(
                                              0,
                                              file.uploadDateTime.indexOf(",")
                                            )}
                                          </p>
                                          <span>• {file.fileSize}</span>
                                        </div>
                                      </div>
                                    </a>
                                    {file.isFolder === false && (
                                      <a
                                        className="dropdown-item dropdown-item-custom"
                                        href="#"
                                        onClick={() => shareFile(file)}
                                      >
                                        <img
                                          src={shareIcon}
                                          alt="Share"
                                          className="dropdown-icon-list"
                                        />
                                        Share
                                      </a>
                                    )}
                                    {file.isFolder === false && (
                                      <a
                                        className="dropdown-item dropdown-item-custom"
                                        href="#"
                                        onClick={() => {
                                          setIsVisibility(true);
                                          setVisiKey(file.fileName);
                                          setPubPri(file.ACL);
                                        }}
                                      >
                                        <img
                                          src={eyeIcon}
                                          alt="Share"
                                          className="dropdown-icon-list"
                                        />
                                        Change Visibility
                                      </a>
                                    )}

                                    {file.fileName.includes(".zip") ? (
                                      <a
                                        className={`dropdown-item dropdown-item-custom ${
                                          file?.isShared
                                            ? "disabled blur-effect"
                                            : ""
                                        }`}
                                        href="#"
                                        onClick={() =>
                                          !file?.isShared && UnzipFile(file)
                                        }
                                        style={
                                          file?.isShared
                                            ? {
                                                pointerEvents: "none",
                                                opacity: 0.5,
                                              }
                                            : {}
                                        }
                                      >
                                        <img
                                          src={UnZipIcon}
                                          alt="Unzip"
                                          className="dropdown-icon-list"
                                        />
                                        Unzip
                                      </a>
                                    ) : (
                                      <a
                                        className={`dropdown-item dropdown-item-custom ${
                                          file?.isShared
                                            ? "disabled blur-effect"
                                            : ""
                                        }`}
                                        href="#"
                                        onClick={() =>
                                          !file?.isShared && ZipFile(file)
                                        }
                                        style={
                                          file?.isShared
                                            ? {
                                                pointerEvents: "none",
                                                opacity: 0.5,
                                              }
                                            : {}
                                        }
                                      >
                                        <img
                                          src={ZipIcon}
                                          alt="Zip"
                                          className="dropdown-icon-list"
                                        />
                                        Zip
                                      </a>
                                    )}
                                    {/* {file.isFolder === false && ( */}
                                    <a
                                      className={`dropdown-item dropdown-item-custom ${
                                        file?.isShared
                                          ? "disabled blur-effect"
                                          : ""
                                      }`}
                                      href="#"
                                      onClick={() =>
                                        !file?.isShared && downloadFile(file)
                                      }
                                      style={
                                        file?.isShared
                                          ? {
                                              pointerEvents: "none",
                                              opacity: 0.5,
                                            }
                                          : {}
                                      }
                                    >
                                      <img
                                        src={downloadIcon}
                                        alt="Download"
                                        className="dropdown-icon-list"
                                      />
                                      Download
                                    </a>
                                    {/* // )} */}
                                    <a
                                      className="dropdown-item dropdown-item-custom"
                                      href="#"
                                      onClick={() => handleOpenPopover(file)}
                                    >
                                      <img
                                        src={renameIcon}
                                        alt="Rename"
                                        className="dropdown-icon-list"
                                      />
                                      Rename
                                    </a>
                                    {/* {file.isFolder === false && (
                                    <a
                                      className="dropdown-item dropdown-item-custom"
                                      href="#"
                                      onClick={() => handleAddToFavorites(file)}
                                    >
                                      <img
                                        src={favouritesIcon}
                                        alt="Add to Favorites"
                                        className="dropdown-icon-list"
                                      />
                                      Add to Favorites
                                    </a>
                                  )} */}
                                    <a
                                      className="dropdown-item dropdown-item-custom"
                                      href="#"
                                      onClick={() => {
                                        if (file.isFolder) {
                                          handleMFClick(file.fileName);
                                        } else {
                                          handleMClick(file.fileName);
                                        }
                                      }}
                                    >
                                      <img
                                        src={moveIcon2}
                                        alt="Move"
                                        className="dropdown-icon-list"
                                      />
                                      Move to
                                    </a>
                                    {file.isFolder === false && (
                                      <a
                                        className="dropdown-item dropdown-item-custom"
                                        href="#"
                                        onClick={() =>
                                          handleCClick(file.fileName)
                                        }
                                      >
                                        <img
                                          src={copyIcon}
                                          alt="Copy"
                                          className="dropdown-icon-list"
                                        />
                                        Copy to
                                      </a>
                                    )}
                                    {/* {file.isFolder === false && (
                                    <a
                                      className="dropdown-item dropdown-item-custom"
                                      href="#"
                                      onClick={() => handleGenerateLink(file)}
                                    >
                                      <img
                                        src={linkIcon}
                                        alt="Generate Short Link"
                                        className="dropdown-icon-list"
                                      />
                                      Generate Short Link
                                    </a>
                                  )} */}
                                    {/* {file.isFolder === false && (
                                    <a
                                      className="dropdown-item"
                                      href="#"
                                      onClick={() => {
                                        setInfoShower(true);
                                        getFileInfo(file.fileName);
                                      }}
                                      
                                    >
                                      <i className="mdi mdi-information-outline" />
                                      Information
                                    </a>
                                  )} */}

                                    <a
                                      className="dropdown-item dropdown-item-custom"
                                      href="#"
                                      onClick={() =>
                                        handleOpenDeletePopover(file)
                                      }
                                    >
                                      <img
                                        src={deleteIcon2}
                                        alt="Delete"
                                        className="dropdown-icon-list"
                                      />
                                      Delete
                                    </a>
                                  </div>
                                </div>
                              </div>

                              {/* File Icon */}
                              <div className="file-icon2">
                                <img src={file.icon} height={32} />
                              </div>

                              <div>
                                {/* File Name */}
                                <div
                                  className="file-name2"
                                  style={{
                                    cursor: "pointer",
                                    whiteSpace: "nowrap", // Prevents text wrapping
                                    overflow: "hidden", // Hides overflow
                                    textOverflow: "ellipsis", // Adds "..."
                                    maxWidth: "100%", // Ensures it stays within the container
                                  }}
                                  title={removeSlash(file.fileName)} // Tooltip to show full filename on hover
                                >
                                  {customTruncateFileName(
                                    removeSlash(file.fileName),
                                    55
                                  )}
                                </div>

                                {/* Date & Items */}
                                <div
                                  className="file-info2"
                                  style={{ textAlign: "left" }}
                                >
                                  <span className="file-date2">
                                    {file.uploadDateTime.substring(
                                      0,
                                      file.uploadDateTime.indexOf(",")
                                    )}
                                  </span>
                                  <span className="file-items2">
                                    • {file.fileSize}
                                  </span>
                                </div>
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    </>
                  )}
                </div>
              )}

              {isWhisperClicked && (
                <MoveFilePopup
                  moveKey={movedFile}
                  source={path}
                  onClose={handleMClose}
                  files={keys}
                  folders={keys2}
                  reloadAfterTast={reloadAfterTast}
                />
              )}

              {moveFol && (
                <MoveFolderPopup
                  moveKey={movedFol}
                  source={""}
                  onClose={handleMFClose}
                />
              )}

              {showFolderModal && (
                <SelectFolderModal
                  onClose={() => setShowFolderModal(false)}
                  onSelect={(selectedPath) => {
                    // console.log("Folder selected:", selectedPath); // Debugging log
                    if (currentFileToZip) {
                      processZipFile(currentFileToZip, selectedPath || ""); // Default to ""
                    }
                    setShowFolderModal(false);
                  }}
                />
              )}

              {showFolderModalUnZip && (
                <SelectFolderModal
                  onClose={() => setShowFolderModalUnZip(false)}
                  onSelect={(selectedPath) => {
                    // console.log("Unzip destination selected:", selectedPath);
                    if (currentFileToUnzip) {
                      processUnzipFile(currentFileToUnzip, selectedPath || ""); // Ensure empty string for root
                    }
                    setShowFolderModalUnZip(false);
                  }}
                />
              )}

              {isCWhisperClicked && (
                <CopyFilePopup
                  moveKey={copiedFile}
                  source={path}
                  onClose={handleCClose}
                  files={keys}
                />
              )}
            </div>
          </div>

          {/* <Footer /> */}
          <footer
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "16px 24px",
              backgroundColor: "#ffffff",
              boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.1)", // nice top shadow
              borderTop: "1px solid #e0e0e0", // subtle top border
              zIndex: 10,
            }}
          >
            <div className="container-fluid ">
              <div className="pagination-container">
                <div className="results-dropdown">
                  <span className="label">Results per page</span>
                  <select
                    value={itemsPerPage}
                    onChange={(e) => pageFilter(Number(e.target.value))}
                    className="select-dropdown"
                  >
                    {data.map((item) => (
                      <option key={item.value} value={item.value}>
                        {item.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="page-info">
                  <span className="page-range">
                    {currentPage > 1 ? currentPage * 10 - 9 : currentPage} to{" "}
                    {currentPage > 1
                      ? currentPage ===
                        Math.ceil(responseData.length / endIndex)
                        ? responseData.length
                        : currentPage * 10
                      : paginatedData.length}{" "}
                    of {responseData.length}
                  </span>

                  <div className="pagination-buttons">
                    {/* First Page */}
                    <button
                      onClick={() => setCurrentPage(1)}
                      disabled={currentPage === 1}
                      className="page-btn"
                    >
                      <ChevronFirst className="icon" />
                    </button>

                    {/* Previous Page */}
                    <button
                      onClick={() => setCurrentPage(currentPage - 1)}
                      disabled={currentPage === 1}
                      className="page-btn"
                    >
                      <ChevronLeft className="icon" />
                    </button>

                    {/* Current Page */}
                    <span className="current-page">{currentPage}</span>

                    {/* Next Page */}
                    <button
                      onClick={() => setCurrentPage(currentPage + 1)}
                      disabled={currentPage >= totalPages}
                      className="page-btn"
                    >
                      <ChevronRight className="icon" />
                    </button>

                    {/* Last Page */}
                    <button
                      onClick={() => setCurrentPage(totalPages)}
                      disabled={currentPage >= totalPages}
                      className="page-btn"
                    >
                      <ChevronLast className="icon" />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="card-header use_storage">
              <span>This folder is using {value}</span>
            </div> */}
          </footer>
        </div>
        {/* main-panel ends */}
      </div>

      {/*All files Shower */}
      <Modal
        open={showImage}
        onClose={handleImageClose}
        className="file_upload_modal_style"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          padding: "0",
          borderRadius: "15px",
          margin: "auto",
        }}
      >
        <div
          id="modal-container"
          style={{
            width: isFullscreen ? "100vw" : "100%",
            maxWidth: isFullscreen ? "none" : "720px",
            backgroundColor: "white",
            borderRadius: "8px",
            overflow: "hidden",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            height: isFullscreen ? "100vh" : "90vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Header */}
          <div
            style={{
              padding: "15px 20px",
              textAlign: "center",
              position: "relative",
              borderBottom: "1px solid #eee",
            }}
          >
            <h2
              style={{
                margin: "0",
                color: "#E9A54D",
                fontSize: "20px",
                fontWeight: "500",
              }}
            >
              Uploaded File
            </h2>
            <button
              onClick={handleImageClose}
              style={{
                position: "absolute",
                top: "15px",
                right: "15px",
                background: "none",
                border: "none",
                fontSize: "30px",
                cursor: "pointer",
                color: "#888",
              }}
            >
              ×
            </button>
          </div>

          {/* Content Area */}
          <div
            style={{
              flex: 1,
              padding: "0",
              position: "relative",
              // backgroundColor: "#f9f9f9",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "auto", // Make content scrollable if it exceeds the height
            }}
          >
            <button
              onClick={handlePrev}
              style={{
                position: "fixed",
                left: "20px",
                background: "none",
                border: "none",
                fontSize: "30px",
                cursor: "pointer",
                zIndex: 10,
                backgroundColor: "white",
                borderRadius: "25px",
                padding: "0 15px",
              }}
            >
              ❮
            </button>

            {isProgressVisible ? (
              // Show loader *inside* the content area
              <div
                style={{
                  height: "100px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img src={loaderGif} alt="" style={{ height: "50%" }} />
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  // backgroundColor: isFullscreen
                  //   ? "rgba(0, 0, 0, 0.8)"
                  //   : "rgba(0, 0, 0, 0.5)",
                  padding: isFullscreen ? "0" : "20px",
                  width: isFullscreen ? "100%" : "80%",
                  height: isFullscreen ? "100%" : "90%",
                  transform: `scale(${zoomLevel})`,
                  transition: "transform 0.2s ease-in-out",
                }}
              >
                {videoSrc ? (
                  <ReactPlayer
                    url={
                      isSharedValue
                        ? `${apiUrl}getFileDefault?token=${token}&filePath=${videoSrc}&shared=${filenameRedux}`
                        : `${apiUrl}getFileDefault?token=${token}&filePath=${videoSrc}`
                    }
                    controls
                    playing={true}
                    width="100%"
                    height="100%"
                    style={{
                      maxHeight: isFullscreen ? "90vh" : "80vh",
                    }}
                  />
                ) : pdfSrc ? (
                  <iframe
                    src={pdfSrc}
                    border="0"
                    width="100%"
                    style={{
                      height: isFullscreen ? "100%" : "220px",
                      border: "none",
                      backgroundColor: "white",
                    }}
                  />
                ) : imageSrc ? (
                  <img
                    src={imageSrc}
                    alt="Image format not supported"
                    style={{
                      maxWidth: isFullscreen ? "90vw" : "100%",
                      maxHeight: isFullscreen ? "90vh" : "80vh",
                      objectFit: "contain",
                      borderRadius: "6px",
                      transform: `scale(${zoomLevel})`, // Apply zoom effect
                      transition: "transform 0.2s ease-in-out", // Smooth zoom animation
                    }}
                  />
                ) : audioSrc ? (
                  <div className="audio_player_modal">
                    <audio
                      controls
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        position: "relative",
                      }}
                    >
                      <source src={audioSrc} type="audio/ogg" />
                      <source src={audioSrc} type="audio/mpeg" />
                      <source src={audioSrc} type="audio/wav" />
                      <source src={audioSrc} type="audio/mp3" />
                      Your browser does not support the audio element.
                    </audio>
                  </div>
                ) : errorMessage2 ? (
                  <p>{errorMessage2}</p>
                ) : (
                  <p></p>
                )}
              </div>
            )}
            <button
              onClick={handleNext}
              style={{
                position: "fixed",
                right: "20px",
                background: "none",
                border: "none",
                fontSize: "30px",
                cursor: "pointer",
                zIndex: 10,
                backgroundColor: "white",
                borderRadius: "25px",
                padding: "0 15px",
              }}
            >
              ❯
            </button>
          </div>

          <div style={{ padding: "15px 20px" }}>
            <div
              style={{
                marginBottom: "15px",
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column", // stack label and scroll area
              }}
            >
              <label
                style={{
                  fontWeight: "500",
                  marginBottom: "8px",
                  display: "block",
                  fontSize: isFullscreen ? "18px" : "14px", // Increase font size in fullscreen mode,
                  marginBottom: "0px",
                }}
              >
                Move file to :
              </label>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  overflowX: "auto",
                  gap: "20px",
                  whiteSpace: "nowrap",
                  width: "100%",
                  paddingBottom: "5px",
                }}
                className="scrollable-div"
              >
                {folderOptions
                  .filter(
                    (folder) =>
                      folder.value.trim() !== "" && folder.label.trim() !== ""
                  )
                  .map((folder) => (
                    <div
                      key={folder.value}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        whiteSpace: "nowrap",
                        flexShrink: 0,
                      }}
                    >
                      <input
                        type="radio"
                        id={folder.value}
                        name="folder"
                        value={folder.value}
                        checked={selectedFolder === folder.value}
                        onChange={handleChange}
                        style={{ marginRight: "5px", flexShrink: 0 }}
                      />
                      <label
                        htmlFor={folder.value}
                        title={folder.label.replace(/</g, "/")} // tooltip shows full path with slashes
                        style={{
                          fontSize: isFullscreen ? "17px" : "15px",
                          display: "block",
                          marginBottom: "0px",
                          whiteSpace: "nowrap",
                          flexShrink: 0,
                        }}
                      >
                        {folder.label.replace(/</g, "/")}
                      </label>
                    </div>
                  ))}
              </div>
            </div>

            {/* Footer with Buttons */}
            <div
              style={{
                padding: "15px 20px",
                borderTop: "1px solid #eee",
                backgroundColor: "white",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#f5f5f5",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                >
                  <Button onClick={zoomIn}>
                    <img
                      src={zoomin}
                      alt="Zoom In"
                      style={{ width: "19px", height: "19px" }}
                    />
                  </Button>
                  Zoom
                  <Button onClick={zoomOut}>
                    <img
                      src={zoomout}
                      alt="Zoom Out"
                      style={{ width: "19px", height: "19px" }}
                    />
                  </Button>
                </div>

                <button
                  onClick={toggleFullscreen}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "8px 12px",
                    backgroundColor: "#f5f5f5",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                >
                  <img
                    src={fullscreeen}
                    alt="Zoom Out"
                    style={{
                      width: "15px",
                      height: "15px",
                      marginRight: "6px",
                    }}
                  />
                  {isFullscreen ? "Exit Fullscreen" : "Fullscreen"}
                </button>

                <button
                  onClick={() => deleteFromModal(modalFile)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "8px 12px",
                    backgroundColor: "#f5f5f5",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                >
                  <img
                    src={deleteIcon3}
                    alt="Zoom Out"
                    style={{
                      width: "15px",
                      height: "15px",
                      marginRight: "6px",
                    }}
                  />
                  Remove
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        open={openFileUploadModal}
        onClose={handleCloseFileUploadModal}
        className="pdf_modal_style file_upload_modal_style"
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Modal.Body style={{ width: "100%" }}>
          <div className="">
            <Tabs>
              <TabList className="my-tab-list">
                <Tab>
                  <div className="my-tab-item">
                    <i className="mdi mdi-file-document-box-multiple-outline"></i>
                    <span>Files</span>
                  </div>
                </Tab>
                <Tab>
                  <div className="my-tab-item">
                    <i className="mdi mdi-folder-multiple-outline"></i>
                    <span>Upload Folder</span>
                  </div>
                </Tab>
                <Tab>
                  <div className="my-tab-item">
                    <i className="mdi mdi-folder-multiple-outline"></i>
                    <span>Folder</span>
                  </div>
                </Tab>
              </TabList>

              <TabPanel>
                <Dropzone onDrop={onDrop}>
                  {({ getRootProps, getInputProps }) => (
                    <section className="" style={{ paddingBottom: "0px" }}>
                      <div {...getRootProps({ className: "fileupload" })}>
                        <input {...getInputProps()} />

                        {/* Background Image with all icons */}
                        <img
                          src={BackgroundImageFileUpload}
                          alt="background-icons"
                          className="background-img"
                        />

                        {/* Center Upload Icon */}
                        <div className="upload-icon-container">
                          <img
                            src={UploadIcon}
                            alt="upload-icon"
                            className="upload-icon"
                          />
                        </div>
                      </div>

                      <ul className="upload_thumbnails_list">{fileList2}</ul>
                    </section>
                  )}
                </Dropzone>
                <div className="filesize-warning-div">
                  <span className="filesize-warning-span">
                    <div class="warning-icon">!</div>Max File size is 5 GB
                  </span>
                  <p className="visibility-label">Set Visibility:</p>
                </div>

                <ul className="radio_checkbox_list mt-0">
                  <li>
                    <input
                      type="radio"
                      name="FileUpload"
                      id="FilePublic"
                      value="public-read"
                      onChange={handlePubChange}
                    />
                    <label htmlFor="FilePublic">Public</label>
                  </li>
                  <li>
                    <input
                      type="radio"
                      name="FileUpload"
                      id="FilePrivate"
                      value="private"
                      onChange={handlePubChange}
                      defaultChecked
                    />
                    <label htmlFor="FilePrivate">Private</label>
                  </li>
                </ul>

                <div className="btn_group mt-4">
                  <button
                    onClick={handleCloseFileUploadModal}
                    className=" btn_width_same btn_grey_ripple ripple_effect btn-cancel"
                  >
                    Close
                  </button>
                  <button
                    onClick={handleFileUpload}
                    className="btn_width_same ripple_effect btn-upload"
                  >
                    Submit
                  </button>
                </div>
              </TabPanel>

              <TabPanel>
                <h5 className="upload-title">Upload Folder</h5>

                <div {...getRootProps({ className: "dropzone-box" })}>
                  <input {...getInputProps()} />
                  <p className="dropzone-text">
                    {isDragActive
                      ? "Drop the folder here ..."
                      : "Choose a file or drag & drop it here"}
                  </p>
                  <p className="dropzone-subtext">
                    JPEG, PNG, PDG, and MP4 formats, up to 50MB
                  </p>
                  <button
                    type="button"
                    onClick={handleSelectFolder}
                    className="browse-button"
                  >
                    Browse File
                  </button>
                </div>

                {files.length > 0 && (
                  <ul className="upload-folder-name">{nameOfFolder}</ul>
                )}

                <div className="visibility-group">
                  <p className="visibility-label">Set Visibility:</p>
                  <ul className="radio_checkbox_list justify-center">
                    <li>
                      <input
                        type="radio"
                        name="FileUpload3"
                        onChange={handleRadioChange2}
                        value="public-read"
                        id="FilePublic3"
                      />
                      <label htmlFor="FilePublic3">Public</label>
                    </li>
                    <li>
                      <input
                        type="radio"
                        name="FileUpload3"
                        onChange={handleRadioChange2}
                        value="private"
                        id="FilePrivate3"
                        defaultChecked
                      />
                      <label htmlFor="FilePrivate3">Private</label>
                    </li>
                  </ul>
                </div>

                <div className="btn_group mt-4">
                  <button
                    onClick={handleCloseFileUploadModal}
                    className=" btn_width_same btn_grey_ripple ripple_effect btn-cancel"
                  >
                    Close
                  </button>
                  <button
                    onClick={uploadFolder}
                    className="btn_width_same ripple_effect btn-upload"
                  >
                    Upload
                  </button>
                </div>
              </TabPanel>

              <TabPanel style={{ display: "flex", justifyContent: "center" }}>
                <div
                  className="create-folder-card"
                  style={{ boxShadow: "none" }}
                >
                  <div
                    className="folder-icon"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <img
                      src={createFolderPopup}
                      alt="Create Folder"
                      height={48}
                    />
                  </div>
                  <h5 className="folder-title">Create Folder</h5>

                  <form
                    className="folder-form"
                    onSubmit={createJustFolder}
                    action="javascript:void(0);"
                    method="POST"
                  >
                    <input
                      className="folder-input"
                      type="text"
                      name="fname"
                      id="folname"
                      pattern="[a-zA-Z0-9_\- ]{1,}"
                      required
                      placeholder="Enter Folder Name"
                    />

                    {folderFieldError && (
                      <p className="error-message">{folderFieldError}</p>
                    )}

                    <div className="rename_buttons mt-4">
                      <button
                        type="button"
                        className="btn_width_same btn_grey_ripple ripple_effect rename_btn cancel"
                        onClick={handleCloseFileUploadModal}
                      >
                        Close
                      </button>

                      <button
                        type="submit"
                        className=" btn_width_same ripple_effect rename_btn ok"
                      >
                        Create
                      </button>
                    </div>
                  </form>
                </div>
              </TabPanel>
            </Tabs>
          </div>
        </Modal.Body>
      </Modal>

      {createFolderButton && (
        <div className="popup-overlay">
          <div className="create-folder-card">
            <div
              className="folder-icon"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <img src={createFolderPopup} alt="Create Folder" height={48} />
            </div>
            <h5 className="folder-title">Create Folder</h5>

            <form
              className="folder-form"
              onSubmit={createJustFolder}
              action="javascript:void(0);"
              method="POST"
            >
              <input
                className="folder-input"
                type="text"
                name="fname"
                id="folname"
                pattern="[a-zA-Z0-9_\- ]{1,}"
                required
                placeholder="Enter Folder Name"
              />
              {folderFieldError && (
                <p className="error-message">{folderFieldError}</p>
              )}

              <div className="rename_buttons mt-4">
                <button
                  className="rename_btn cancel"
                  onClick={handleCloseCreateFolder}
                >
                  Close
                </button>
                <button type="submit" className="rename_btn ok">
                  Create
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      <DownloadModal
        isOpen={isDownloadModalOpen}
        onClose={() => setIsDownloadModalOpen(false)}
        onDownload={handleDownload}
        openPathSelectionModal={openPathSelectionModal}
        path={path} // Pass path here
        reloadAfterTast={reloadAfterTast}
      />
    </>
  );
};

export default NestedPage;
